<template>
  <aicc-page :titleShow="false">
    <ur-area>

      <div class="pop_header" style="padding-left: 8px; padding-top: 48px; padding-bottom: 24px; margin-bottom: 0px;">
        <p class="pop_title">{{popupTitle}}</p>
      </div>

      <aicc-step-box :steps="steps" @moveStep="onMoveStep" @action="onClickComplete" action-label="완료" prevLabel="이전" nextLabel="다음" ref="stepBox">
        <!-- ur-step-item의 높이를 모두 같게 해야 아래 버튼의 위치가 모두 같게 된다. -->
        
        <ur-step-item style="height: 543px;">
          <div class="tbl_write">
          <table>
            <caption>캠페인 만들기</caption>
            <colgroup>
              <col style="width:192px">
              <col style="width:auto">
            </colgroup>
            <tbody>
              <tr>
                <th colspan="2" scope="row">
                  <div class="tit_area">
                  <!-- <h2 class="sub_title">새로운 캠페인 이름과 시나리오를 선택하여 캠페인을 구성해 보세요. </h2> -->
                  <h2 class="sub_title">{{$t('MSG_TIT_CAMPAIGN_REG_STEP1')}}</h2>
                  </div>
                </th>
              </tr>
              <tr>
                <th scope="row">{{$t('MSG_TXT_CAMPAIGN_NAME')}} <span class="essential">*</span></th>
                <td>
                  <aicc-text-field @input="checkValidStep1ScheduleName" v-model="scheduleNameModel" :rules="scheduleNameValidateRule" @blur="onBlur" 
                    :disabled="updateMode && outCallSchedule.scheduleStatus !== 'A' && outCallSchedule.scheduleStatus !=='B'" 
                    placeholder = '캠페인 이름을 입력해주세요.' :counter="maxScheduleNameLength" style="width:680px;" 
                    ref="refScheduleName" :key="byteKeyScheduleName"/>
                </td>
              </tr>
              <tr>
                <th scope="row">{{$t('MSG_TXT_SCENARIO')}} <span class="essential">*</span></th>
                <td>
                  <ur-dropdown @input="checkValidStep1Scenario" :items="selectScenarioOptions" style="width:680px;" v-model="selectedScenario" value="selectedScenario"
                  :disabled="updateMode && outCallSchedule.scheduleStatus !== 'A' && outCallSchedule.scheduleStatus !=='B'"
                  placeholder='시나리오를 선택해 주세요.'/>
                </td>
              </tr>
              <tr>
                <th scope="row">{{$t('MSG_TXT_DETAIL_CNTN')}}</th>
                <td>
                  <aicc-text-area @input="checkValidStep1ScheduleDescription" v-model="scheduleDescriptionValue" :rules="scheduleDescriptionValidateRule" 
                    :disabled="updateMode && outCallSchedule.scheduleStatus !== 'A' && outCallSchedule.scheduleStatus !=='B' && outCallSchedule.scheduleStatus !== 'E'"
                    placeholder = '캠페인에 대한 설명을 입력해주세요. (선택)' :counter="maxScheduleDescriptionLength" rows="7"
                    style="width:680px; height:250px" ref="refScheduleDescription" :key="byteKeyScheduleDescription"/>
                </td>
              </tr>
            </tbody>
          </table>
          </div>
        </ur-step-item>

        <ur-step-item style="height: 543px;">
          <div class="box_gray">
            <dl>
              <dt v-if="scheduleNameValue">{{scheduleNameValue}}</dt>
              <dd v-if="selectedScenarioName"><strong>시나리오</strong>{{selectedScenarioName}}</dd>
            </dl>
          </div>

          <div class="tbl_write">
            <table>
              <caption>새 캠페인 만들기</caption>
              <colgroup>
                <col style="width:192px">
                <col style="width:auto">
              </colgroup>
              <tbody>
                <tr>
                  <th colspan="2" scope="row">
                    <div class="tit_area">
                    <!-- <h2 class="sub_title">캠페인을 수행할 일정과 발신번호, 콜 옵션을 선택해주세요.</h2> -->
                    <h2 class="sub_title">{{$t('MSG_TIT_CAMPAIGN_REG_STEP2')}}</h2>
                    </div>
                  </th>
                </tr>
                <tr>
                  <th scope="row">수행일정 <span class="essential">*</span></th>
                  <td>
                    <div>
                      <aicc-range-picker @input="checkValidStep2" v-model="dateRangeValue" autoConfirm strictRange 
                        :disabled="updateMode && outCallSchedule.scheduleStatus !== 'A' && outCallSchedule.scheduleStatus !=='B'"/>
                    </div>
                    <div class="check_wrap">
                      <span class="checkbox">  
                        <ur-checkbox @input="checkValidStep2" v-model="excludeSaturday" 
                          :disabled="updateMode && outCallSchedule.scheduleStatus !== 'A' && outCallSchedule.scheduleStatus !=='B'">
                          <label for="chk1" style="cursor:pointer;"> {{$t('MSG_TXT_EXCLUDE_SAT')}}</label>
                        </ur-checkbox>
                      </span>&nbsp;&nbsp;&nbsp;&nbsp;
                      <span class="checkbox">
                        <ur-checkbox @input="checkValidStep2" v-model="excludeSundayHoliday" 
                          :disabled="updateMode && outCallSchedule.scheduleStatus !== 'A' && outCallSchedule.scheduleStatus !=='B'">
                          <label for="chk2" style="cursor:pointer;"> {{$t('MSG_TXT_EXCLUDE_SUN_AND_HOLI')}}</label>
                        </ur-checkbox>
                      </span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">수행시간 <span class="essential">*</span></th>
                  <td>
                    <div style="float:left">
                      <aicc-time-picker :class="aiccTimePickerClass" style="width:180px" @input="checkValidStep2" v-model="startTimeLimitValue" 
                        :disabled="updateMode && outCallSchedule.scheduleStatus !== 'A' && outCallSchedule.scheduleStatus !=='B'" 
                        mode="stepper" :containMrdm="false" :fullTimeText="true"/>
                    </div>
                    <div style="float:left;padding:5px 10px 0 7px"> ~ </div>
                    <div style="float:left"> 
                      <aicc-time-picker :class="aiccTimePickerClass" @input="checkValidStep2" v-model="endTimeLimitValue" 
                        :disabled="updateMode && outCallSchedule.scheduleStatus !== 'A' && outCallSchedule.scheduleStatus !=='B'" 
                        mode="stepper" :containMrdm="false" :fullTimeText="true"/>
                    </div>
                    <div class="timeLimitError" v-show="timeLimitError">{{timeLimitMsg}}</div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">발신번호 <span class="essential">*</span></th>
                  <td>
                    <ur-dropdown @input="checkValidStep2" :items="selectSipNumberOptions" v-model="selectedSipNumber" 
                      :disabled="updateMode && outCallSchedule.scheduleStatus !== 'A' && outCallSchedule.scheduleStatus !=='B'"
                      style="width:610px;" placeholder="발신번호를 선택해 주세요."/>
                    <p class="txt_desc" v-if="this.ongoingScheduleCnt > 0"> 
                      * 해당 번호 및 일정에 이미 등록된 캠페인 <span class="link" @click="onClickOngingPopup">{{ongoingScheduleCntInfo}}건</span>이 있습니다. 
                        동시 수행 시, 캠페인 별 동일한 비중(Round-Robin)으로 발신됩니다.   
                    </p>
                  </td>
                </tr>
                <tr>
                  <th scope="row">{{$t('MSG_TXT_CALL_RETRY_COUNT')}} <span class="essential">*</span></th>
                  <td>
                    <div style="float:left">
                      <div style="float:left">
                        <ur-stepper @input="checkValidStep2" v-model="selectedRetryCount" 
                          :disabled="updateMode && outCallSchedule.scheduleStatus !== 'A' && outCallSchedule.scheduleStatus !=='B'"
                          :min="1" :max="3" @change="onChangeRetryCount" controlType='updown' style="width:80px;" />
                      <span> 회 시도</span>   
                      </div> 
                      <div class="form_wrap" style="float:left" v-show="showRetryInterval">
                        <div style="float:left"> <em class="bar"></em>  </div>
                        <span class="label" style="float:left">재시도 정책</span>     
                        <div style="float:left"> 
                          <ur-dropdown @input="checkValidStep2" :items="selectRetryIntervalOptions" 
                            :disabled="updateMode && outCallSchedule.scheduleStatus !== 'A' && outCallSchedule.scheduleStatus !=='B'"
                            v-model="selectedRetryInterval" style="width:240px;"/>
                        </div>
                      </div>
                    </div>
                    <div style="display:inline-block;" v-show="showRetryInterval">
                      <p class="txt_desc" v-if="selectedRetryInterval === 'A'">*수신리스트 전체를 1차 통화시도 후, 1차 실패 건에 대한 2차 시도 / 2차 실패 건에 대한 3차 시도 수행이 순차적으로 이루어집니다.
                      <p class="txt_desc" v-else>*콜 연결 실패 시 1시간 간격으로 재시도를 수행합니다. 단, 지정된 캠페인 일시 내에서만 수행됩니다.<br>(종료 시간 넘어가면 익일 수행, 캠페인 일정 종료 시 수행 중단)</p>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>  

        </ur-step-item>

        <ur-step-item style="height: 543px;">
            <div class="box_gray">
              <dl>
                <dt v-if="scheduleNameValue">{{scheduleNameValue}}</dt>
                <dd v-if="selectedScenarioName"><strong>시나리오</strong>{{selectedScenarioName}}</dd>
                <dd><strong>수행일자/시간</strong>{{startDateValue}}~{{endDateValue}}({{startTimeLimitValue.substr(0,5)}}~{{endTimeLimitValue.substr(0,5)}})</dd>
                <dd v-if="diplaySipNumber"><strong>발신번호</strong>{{diplaySipNumber}}</dd>
              </dl>
            </div>

            <div class="tbl_write">
              <table>
                <caption>캠페인 만들기</caption>
                <colgroup>
                  <col style="width:192px">
                  <col style="width:auto">
                </colgroup>
                <tbody>
                  <tr>
                    <th colspan="2" scope="row">
                      <div class="tit_area">
                      <!-- <h2 class="sub_title">캠페인 수신리스트를 작성해주세요.</h2> -->
                      <h2 class="sub_title">{{$t('MSG_TIT_CAMPAIGN_REG_STEP3')}}</h2>
                      <div class="file_upload">
                        <ur-text-field :disabled="true" v-model="uploadedFilename" placeholder = 'CSV.형식 파일 업로드' style="width:340px;" ref="uploadFileName"/>&nbsp;
                        <input id="fileUploader" type="file" @change="onClickCsvUpload" accept=".csv" ref="fileUploader" style="display:none"/>
                        <ur-button shape="solid" primary @click="onClickFileUpdate">파일 업로드</ur-button>
                        <ur-button @click="onClickDownload">수신양식 다운로드</ur-button>
                      </div>
                      </div>
                    </th>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-show="calleeTotalCnt > 0">
              <div class="filter_box">

                <ur-filter-chip v-model="showAllGuideMsg"
                    v-show="calleeNumberTypeErrorCnt > 0 || reservationDateTypeErrorCnt > 0 || reservationTimeTypeErrorCnt > 0 || 
                            periodDateFaultCnt > 0 || periodTimeFaultCnt > 0 || 
                            dupCalleeNumberCnt > 0 || scriptOrderErrorCnt > 0 || dupReservationDateCnt > 0" 
                            
                    @click="onClickAllChips">전체</ur-filter-chip>
                 
                <ur-filter-chip v-model="showCalleeNumberTypeErrorMsg" v-show="calleeNumberTypeErrorCnt > 0" color="red" 
                    @click="onClickCalleeNumberTypeErrorChip">수신번호 오류 {{calleeNumberTypeErrorCntInfo}}</ur-filter-chip>
                
                <ur-filter-chip v-model="showReservationDateTypeErrorMsg" v-show="reservationDateTypeErrorCnt > 0" color="red" 
                    @click="onClickReservationDateTypeErrorChip">예약일자 오류 {{reservationDateTypeErrorCntInfo}}</ur-filter-chip>

                <ur-filter-chip v-model="showReservationTimeTypeErrorMsg" v-show="reservationTimeTypeErrorCnt > 0" color="red" 
                    @click="onClickReservationTimeTypeErrorChip">예약시간 오류 {{reservationTimeTypeErrorCntInfo}}</ur-filter-chip>                    

                <ur-filter-chip v-model="showPeriodDateFaultMsg" v-show="periodDateFaultCnt > 0"  color="red"
                    @click="onClickPeriodDateFaultChip">수행일자 불일치 {{periodDateFaultCntInfo}}</ur-filter-chip>

                <ur-filter-chip v-model="showPeriodTimeFaultMsg" v-show="periodTimeFaultCnt > 0"  color="red"
                    @click="onClickPeriodTimeFaultChip">수행일시 불일치 {{periodTimeFaultCntInfo}}</ur-filter-chip>                    

                <ur-filter-chip v-model="shoDupCalleeNumberMsg" v-show="dupCalleeNumberCnt > 0"  color="orange"
                    @click="onClickDupCalleeNumberChip">동일 수신번호 {{dupCalleeNumberCntInfo}}</ur-filter-chip>

                <ur-filter-chip v-model="showScriptOrderErrorMsg" v-show="scriptOrderErrorCnt > 0"  color="orange"
                    @click="onClickScriptOrderErrorChip">대화ID 순서 미지정 {{scriptOrderErrorCntInfo}}</ur-filter-chip>
                
                <ur-filter-chip v-model="showDupReservationDateMsg" v-show="dupReservationDateCnt > 0" color="orange"
                    @click="onClickDupReservationDateChip">중복예약 일자/시간 {{dupReservationDateCntInfo}}</ur-filter-chip>

                <!-- <ur-filter-chip v-model="showDupReservationTimeMsg" v-show="dupReservationTimeCnt > 0" color="orange"
                    @click="onClickDupReservationTimeChip">중복예약 시간 {{dupReservationTimeCnt}}</ur-filter-chip>                     -->

              </div>
            </div>
            
            <div v-show="showCalleeNumberTypeErrorMsg">
              <!-- <div class="txt_desc error a">* [필수] 수신번호는 0 또는 1로 시작하는 7~20자리 숫자여야 합니다.</div> -->
              <div class="txt_desc error a">{{$t('MSG_TXT_CALLEE_NUMBER_TYPE_ERROR')}}</div>
            </div>
            <div v-show="showReservationDateTypeErrorMsg">
              <!-- <div class="txt_desc error a">* [필수] 예약일자는 YYYY-MM-DD 포맷으로 기재해 주세요.</div> -->
              <div class="txt_desc error a">{{$t('MSG_TXT_RESERVATION_DATE_TYPE_ERROR')}}</div>
            </div>
            <div v-show="showReservationTimeTypeErrorMsg">
              <!-- <div class="txt_desc error a">* [필수] 예약시간은 HH:MM(24시간 4자리) 포맷으로 기재해 주세요.</div> -->
              <div class="txt_desc error a">{{$t('MSG_TXT_RESERVATION_TIME_TYPE_ERROR')}}</div>
            </div>

            <div v-show="showPeriodDateFaultMsg">
              <!-- <div class="txt_desc error b">* [필수] 예약일자는 캠페인 수행일정에 포함되어야 합니다.</div> -->
              <div class="txt_desc error b">{{$t('MSG_TXT_PERIOD_DATE_FAULT')}}</div>
            </div>
            <div v-show="showPeriodTimeFaultMsg">
              <!-- <div class="txt_desc error b">* [필수] 예약시간은 캠페인 수행시간에 포함되어야 합니다.</div> -->
              <div class="txt_desc error b">{{$t('MSG_TXT_PERIOD_TIME_FAULT')}}</div>
            </div>

            <div v-show="shoDupCalleeNumberMsg" >
              <!-- <div class="txt_desc warn b">* [안내] 중복 수신번호는 기재된 순차대로 콜이 수행되며, 한 행마다 지정된 시도 횟수가 반복됩니다.</div> -->
              <div class="txt_desc warn b">{{$t('MSG_TXT_DUP_CALLEE_NUMBER')}}</div>
            </div>
            <div v-show="showScriptOrderErrorMsg">
              <!-- <div class="txt_desc warn d">* [안내] 대화ID 순서 미작성 시, 시나리오 전체가 순차적으로 수행됩니다.</div> -->
              <div class="txt_desc warn d">{{$t('MSG_TXT_SCRIPT_ORDER_ERROR')}}</div>
            </div>

            <div v-show="showDupReservationDateMsg">
              <!-- <div class="txt_desc warn c">* [안내] 중복 예약일자/시간 건은 지정일시에 순차적으로 콜이 수행됩니다.</div> -->
              <div class="txt_desc warn c">{{$t('MSG_TXT_DUP_RESERVATION_DATE')}}</div>
            </div>
            
            <div>
              <ur-data-grid style="min-width: 1184px;" :headers="calleeHeaders" :options="gridOptions" :data-source="dataSet" 
                            @grid:data-changed="onCalleeDataChanged" 
                            @grid:selected="onCalleeSelected"
                            @grid:click="onCalleeClick"
                            @grid:check-click="onCheckClick"                            
                            @grid:btn-add="onCalleeAdd"
                            @grid:btn-modify="onCalleeModify"
                            @grid:btn-delete="onCalleeDelete"
                            @grid:btn-save="onCalleeSave"
                            @grid:btn-cancel="onCalleeCancel"
                            @grid:filtered="onFilterChanged"
                            id="callee-grid" ref="calleeGrid"/>
              <div v-if="showEmptyMsg" class="empty-view">
                파일을 업로드 하거나 직접 추가하여 수신 리스트를 설정해주세요.
              </div>
            </div>
            <div hidden>
              <!-- 수신양식 다운로드를 위한 grid  -->
              <ur-data-grid :headers="csvDownLoadHeaders" :data-source="csvDownloadDataSet" ref="csvGrid"/>
            </div>
        </ur-step-item>

        <template #custom-action>
          <div class="custom-action">
            <ur-button @click="onClickTempSave" :disabled="enabledTemporaryButton">{{ $t("MSG_BTN_TMP_SAVE") }}</ur-button>
            <span class="my-divider" style="margin: 0 10px;">|</span>
            <ur-button @click="onClickRegisterCancel">취소</ur-button>
          </div>
        </template>

      </aicc-step-box>

      <div>
        <ur-snackbar ref="snackbar" :duration="3000"></ur-snackbar>
      </div>

      <ur-modal ref="registerCancelModal" title="알림" @closed="onCloseCancelModal" dragable width=464>
          <template>
              현재 작업중인 내용을 저장하지 않고 창을 닫으시겠습니까?
              <!-- "취소 시, 편집한 내용은 저장되지 않습니다. 취소하시겠습니까?" -->
          </template>
          <template slot="action">
              <ur-button @click="onClickCancel">취소</ur-button>
              <ur-button @click="onClickConfirm" main>확인</ur-button>
          </template>
      </ur-modal>

      <onging-schedule-popup :ongoingSchedules="ongoingSchedules" ref="ongoingModal"/>
    </ur-area>
  </aicc-page>
</template>

<script>
import BasePage from '~cm/components/BasePage';
import {urDataSet} from 'uidev-component/index.js';
import urDataGrid from '@uidev/grid/urDataGrid/urDataGrid';
import ongingSchedulePopup from './components/PGE_AIC_00003_P01';
import { formatFileSize } from '../../../../common/components/form/SuiValidator/i18n/utils';
// import aiccTimePicker from '~common/components/form/AICCTimePicker/AICCTimePicker';

import aiccWsSession from '../../js/AiccWsSession.js';

// 0 또는 1로 시작하고 그 뒤는 0~9로 되는 총 7~20자리 정규식 (authored by byungjae.park)
const DATE_REGEX = /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/;
const TIME_REGEX = /^([01][0-9]|2[0-3]):([0-5][0-9])$/;
const PHONE_REGEX = /^(?:0|1)[0-9]{6,19}$/;

export default {
  name: 'PGE_AIC_00003', // eslint-disable-line vue/name-property-casing
  components: {
    BasePage,
    urDataGrid,
    ongingSchedulePopup,
    aiccWsSession,
  }, 

  data() {
    return {
      uploadedFilename: '',
      mode: '',
      popupTitle: "캠페인 만들기",
      gridLength : 0,
      steps: [{ "name": "캠페인 정보", "valid": false }, 
              { "name": "캠페인 수행", "valid": false, "check": this.onCheckBeforeStepMove}, 
              { "name": "수신리스트" , "valid": false }],
      stepIndex: 0,

      scheduleNameValidateRule: [
        (v) => !!v || '필수 입력 항목입니다.',
        (v) => aiccUtils.getStringByteSize(this.scheduleNameModel) <= this.maxScheduleNameLength || `최대 ${this.maxScheduleNameLength}byte까지 입력 가능합니다.`,
        (v) => this.scheduleNameCheckflag || '이미 사용중인 캠페인 이름입니다.'
      ],
      scheduleNameCheckflag : true,

      // scenarioNameValidateRule: [
      //   (v) => !!v || '필수 입력 항목입니다.',
      // ],

      scheduleDescriptionValidateRule: [
        // (v) => v.length <= 300 || '캠페인 상세 설명은 최대 300자를 넘을 수 없습니다.'
        (v) => aiccUtils.getStringByteSize(this.scheduleDescriptionValue) <= this.maxScheduleDescriptionLength || `최대 ${this.maxScheduleDescriptionLength}byte까지 입력 가능합니다.`,
      ],

      insertMode: false,
      updateMode: false,
      copyMode: false,

      statusStoppedFlag: false,
      showRetryInterval: false,
      temporarySavedFlag: false,
      completeSaveFlag: false,

      // 작성 중 '취소' 누른 경우 확인창 띄우기 위한 flag 및 데이터
      isCancelCheck: false,
      checkScheduleInfo: {
        scheduleNameValue: '',
        selectedScenario: '',
        scheduleDescriptionValue: '',
        startDateValue: '',
        endDateValue: '',
        excludeSaturday: null,
        excludeSundayHoliday: null,
        startTimeLimitValue: '',
        endTimeLimitValue: '',
        selectedSipNumber: '',
        selectedRetryCount: null,
        selectedRetryInterval: '',
      },

      updateData: {},      
      savedSchedule: {},
      
      outCallSipNumbersAsk: {
        tenantId: ''
      },

      outCallScenarioAsk: {
        tenantId: ''
      },

      outCallScenarioVariableAsk: {
        scenarioId: '',
      },

      ongoingOutCallScheduleAsk: {
        sipNumber: '',
        startDate: '',
        endDate: '',
        scheduleId: '',
      },

      outCallScheduleAsk: {
        scheduleId: '',
      },

      outCallScheduleItemsAsk: {
        scheduleId: '',
      },

      outCallScheduleByNameAsk: {
        scheduleName: ''
      },

      outCallSchedule: {
        scheduleId: '',
        scheduleName: '',
        scheduleDescription: '',
        tenantId: '',
        userId: '',
        siteId: '',
        botId: '',
        scenarioId: '',
        scenarioName: '',
        questionNumbers: '',
        sipNumber: '',
        callerId: '',
        retryNumber: '',
        retryInterval: '',
        schedulePriority: '',
        scheduleStatus: '',
        excludeDayofweek: '',
        excludeHolidayYn: '',
        startDate: '',
        endDate: '',
        startTimeLimit: '',
        endTimeLimit: '',
        createdCallees: [],
        updatedCallees: [],
        removedCallees: [],
        isInsert: 'N',
        isUpdate: 'N',
      },

      scheduleNameValue: '',
      scheduleDescriptionValue: '',
      maxScheduleNameLength: 70,
      maxScheduleDescriptionLength: 300,

      startDateValue: '',
      endDateValue: '',
      dateRangeValue: [],

      startTimeLimitValue: '',
      endTimeLimitValue: '',

      // 예약일자, 예약시간이 캠페인 기간내 인지 체크를 위한 변수
      checkStartDate: '',
      checkEndDate: '',
      checkStartTimeLimit: '',
      checkEndTimeLimit: '',

      SUNDAY: '1',
      SATURDAY: '7',
      excludeSaturday: false,
      excludeSundayHoliday: false,

      selectScenarioOptions: [],
      selectedScenario: '',
      selectedScenarioName: '',
      
      selectSipNumberOptions: [],
      selectedSipNumber: '',

      ongoingSchedules: [],
      ongoingScheduleExist: false,
      ongoingScheduleCnt: 0,

      selectedRetryCount: 1,
      selectRetryCountOptions: [
        { value: 1, text: '1' },
        { value: 2, text: '2' },
        { value: 3, text: '3' },
      ],

      selectedRetryInterval: 'A',
      selectRetryIntervalOptions: [
        { value: 'A', text: '첫 시도 우선' },
        { value: 'B', text: '1시간 간격 재시도 우선' },
      ],

      // 수신번호 중복 체크를 위한 Object
      dupCalleeNumberSet : new Set(),
      // 예약일자, 예약시간 중복 체크를 위한 Object
      dupReservationDtSet : new Set(),

      calleeMaxItemIndex: 0,
      calleeItems0 : {
        'calleeNumber' : "01012341234",
        "reservationDate" : '',
        "reservationTime" : '',
        "itemIndex" : 0
      },
      calleeItems : [],
      
      calleeHeadersBase: [],
      calleeHeaders : [
        // {value:'__idx',text:'#', width: 40},
        // {value:'itemIndex', hide:true},
        {value:'columnIndex', text:'#', edit:false, readonly:true, width: 33,
          editComponent : {
              props : ['row','oriValue','text'], // provided by grid
              template :`<input type="text" readonly style="border: none; background-color: inherit;" v-model="value" />`
          },
          customClass: (value, rowInfo, callerComponent) => {
            let itemStatus = rowInfo.row.itemStatus;
            if(typeof itemStatus !== 'undefined' && !utils.isEmpty(itemStatus) && itemStatus !== 'A') {
              return 'grey-cell';
            }
          },
        },
        {value: 'calleeId', text: this.$t('MSG_TXT_CALLEE_ID'), edit: false, readonly: true, width: 80, sort: true, filter: true,
          editComponent: {
            props: ['row', 'oriValue', 'text'], // provided by grid
            template: `<input type="text" readonly style="border: none; background-color: inherit;" v-model="value" />`,
          },
          customClass: (value, rowInfo, callerComponent) => {
            let itemStatus = rowInfo.row.itemStatus;
            if(typeof itemStatus !== 'undefined' && !utils.isEmpty(itemStatus) && itemStatus !== 'A') {
              return 'grey-cell';
            }
          },
        },
        {value:'calleeNumber', text: this.$t('MSG_TXT_CALLEE_NUMBER1'), width: 200, key:true, required:true, sort: true, filter:true, 
          checker: (v, filter) => {
            // console.log(filter);
            if (Array.isArray(filter)) {
              if (filter.length === 0) {
                return false;
              }
              for (let ii = 0; ii < filter.length; ii++) {              
                let filterData = filter[ii];
                // console.log('v', v, 'filterData', filterData);
                if (!!v && v === filterData) {
                  return true;
                }
              }
            } else {
              // console.log('v', v, 'filter', filter);
              // console.log('v.includes(filter)',v.includes(filter))
              if (!!v && v.includes(filter)) {
                  return true;
              }
            }
            return false;        
          },
          
          // value 는 셀에 입력한 값, rowInfo 는 입력한 row 정보, callerComponent 는 Grid를 호출한 component
          customClass: (value, rowInfo, callerComponent) => {
            let itemStatus = rowInfo.row.itemStatus;
            if(typeof itemStatus !== 'undefined' && !utils.isEmpty(itemStatus) && itemStatus !== 'A') {
              return 'grey-cell';
            }

            // 0 또는 1로 시작하는 7자리 이상 20자리 이하 숫자 입력 가능
            if (!PHONE_REGEX.test(value)) {
              return 'red-cell';
            }

            let rootComponent = null;
            let thisComponent = callerComponent;
            while(thisComponent && !rootComponent) {
                if(thisComponent.$options.name === 'PGE_AIC_00003') {
                    rootComponent = thisComponent;
                    break;
                }
                thisComponent = thisComponent.$parent;
            }

            let dupCalleeNumber = rootComponent.dupCalleeNumber;
            if (dupCalleeNumber.has(rowInfo.row.calleeNumber)) {
              return 'orange-cell';
            }
            return '';
          },

          component :  { 
            props : ['row','value','text'], 
            template :`<p>{{text}}</p>`,
            computed : {
            }, 
            methods : {
            }
          },
        },

        {value:'reservationDate', text: this.$t('MSG_TXT_RESERVATION_DATE'), width: 200, sort: true, filter:true, type:'date',
          checker: (v, filter) => {
            // console.log('v', v, v.constructor, 'reservationDate filter', filter)
            // console.log('v', v, "v.constructor", v.constructor, 'reservationDate filter', filter)
            if (Array.isArray(filter)) {              
              if (filter.length === 0) {
                return false;
              }
              for (let ii = 0; ii < filter.length; ii++) {                                            
                let filterData = filter[ii];
                // console.log('--------------')
                // console.log('v', v, 'filterValue', filterData);

                // Date Type 오류인 경우 v, filterData 모두 날짜 형식이 아닌 경우이다.
                if (!utils.isDate(v) && !utils.isDate(filterData)) {
                  if (v === filterData) {
                    return true;
                  }
                } else {
                  // 수행일자 불일치와 중복 예약일자인 경우 v 와 filterData 가 날짜 형식인 것을 비교한다.
                  if (!!v && utils.isDate(v) && utils.isDate(filterData)) {
                    // 예약날짜는 문자열로 처리되므로 문자열을 Date로 바꾸어야 년월일 갖고 오는 함수가 작동한다.
                    let vdate = utils.toDate(v);
                    let fdate = utils.toDate(filterData);
                    if((vdate.getFullYear() === fdate.getFullYear()) && (vdate.getMonth() === fdate.getMonth()) && (vdate.getDate() === fdate.getDate())) {
                      return true;
                    }
                  }
                }
              }
              return false;    

            } else {
              // data grid 내부에서 쓰는 기본 date checker를 쓰지 않고 자체적으로 만들었다.
              // data grid 내부 기본 date check에 보면 아래처럼 돼 있어서 년월일이 같고 시분초가 모두 0일 때는 필터가 되지 않더라.
              // return !!v && st<v && v<ed;  이 소스는 uidev-component/grid/urDataGrid/util/urDataGridUtil.js 안에 export const CHECKER의 date 선언 부분에 있다.
              if(!filter) return false;
              // console.log('v', v, 'f', filter)
              if(!utils.isDate(v)) {return false;}
              return !!v && (utils.toDate(v).getFullYear() === filter.getFullYear()) && (utils.toDate(v).getMonth() === filter.getMonth()) && (utils.toDate(v).getDate() === filter.getDate());
            }
          },

          // component로 정의한 validation Rule을 다시 적용하기 위해 setData를 하는 경우 
          // 수신리스트 변경사항(created, updated, removed)가 모두 초기화되어 customClass 방식으로 변경함.
          // value 는 셀에 입력한 값, rowInfo 는 입력한 row 정보, callerComponent 는 Grid를 호출한 component
          customClass: (value, rowInfo, callerComponent) => {   
            // console.log("value", value, "rwoInfo", rowInfo, "callerComponent", callerComponent)

            // 파일 업로드하면 빈 문자열(""), date picker에서 날짜 지우면 null이더라.
            if(!value) {                  
              return '';
            }

            let itemStatus = rowInfo.row.itemStatus;
            if(typeof itemStatus !== 'undefined' && !utils.isEmpty(itemStatus) && itemStatus !== 'A') {
              return 'grey-cell';
            }

            // Type: 'date' 옵션을 사용하는 경우 'Mon Nov 15 2021 00:00:00 GMT+0900'로 들어오기 때문에 YYYY-MM-DD 형태로 비교한다.
            // DATE_REGEX 정규식은 하이픈 관계 없다고 되어 있지만 하이픈 넣어야 비교가 된다.
            let reservationDate = utils.toStringByFormat(value, "YYYY-MM-DD");
            if (!DATE_REGEX.test(reservationDate)) {
              return 'red-cell';
            }

            let rootComponent = null;
            let thisComponent = callerComponent;
            while(thisComponent && !rootComponent) {
                if(thisComponent.$options.name === 'PGE_AIC_00003') {
                    rootComponent = thisComponent;
                    break;
                }
                thisComponent = thisComponent.$parent;
            }

            // CheckDate와는 YYYYMMDD 형태로 비교한다.
            reservationDate = utils.toStringByFormat(value, "YYYYMMDD");
            if (!utils.isEmpty(reservationDate)) {
              if (reservationDate < rootComponent.checkStartDate || rootComponent.checkEndDate < reservationDate) {
                 return 'red-cell';
              }
            }

            let dupReservationDt = rootComponent.dupReservationDt;
            if (!utils.isEmpty(reservationDate) && !utils.isEmpty(rowInfo.row.reservationTime)) {
              let reservationDateTime = reservationDate + rowInfo.row.reservationTime.replaceAll(":", "");
              if (dupReservationDt.has(reservationDateTime)) {
                return 'orange-cell';
              }
            }

            return '';
          },

          component :  { 
            props : ['row','value','text'], 
            template :`<span>{{text}}</span>`,
            computed : {
            },
            methods : {
            }
          },
        },
        {value:'reservationTime', text: this.$t('MSG_TXT_RESERVATION_TIME'), width: 200, sort: true, filter:true, 
          // display 될 때 사용하는 component
          checker: (v, filter) => {
            // console.log('filter', filter)          
            if (Array.isArray(filter)) {
              if (filter.length === 0) {
                return false;
              }
              // console.log(filter);
              for (let ii = 0; ii < filter.length; ii++) {              
                let filterData = filter[ii];
                // console.log('v', v, 'filterValue', filterData);
                if (!!v && v === filterData) {
                  // console.log('return true;')
                  return true;
                }
              }
            } else {
              // console.log('v', v, 'filter', filter, 'v.includes(filter)',v.includes(filter));
              if (!!v && v.includes(filter)) {
                  return true;
              }
            }
            return false; 
          },

          // component로 정의한 validation Rule을 다시 적용하기 위해 setData를 하는 경우 
          // 수신리스트 변경사항(created, updated, removed)가 모두 초기화되어 customClass 방식으로 변경함.
          // value 는 셀에 입력한 값, rowInfo 는 입력한 row 정보, callerComponent 는 Grid를 호출한 component
          customClass: (value, rowInfo, callerComponent) => {   
            // console.log("value", value, "rwoInfo", rowInfo, "callerComponent", callerComponent)

            if(!value) {
              // 빈 문자열("")은 오류 아님
              return '';
            }
            
            let itemStatus = rowInfo.row.itemStatus;
            if(typeof itemStatus !== 'undefined' && !utils.isEmpty(itemStatus) && itemStatus !== 'A') {
              return 'grey-cell';
            }

            if (!TIME_REGEX.test(value)) {
              return 'red-cell';
            }

            let rootComponent = null;
            let thisComponent = callerComponent;
            while(thisComponent && !rootComponent) {
                if(thisComponent.$options.name === 'PGE_AIC_00003') {
                    rootComponent = thisComponent;
                    break;
                }
                thisComponent = thisComponent.$parent;
            }

            if (!utils.isEmpty(value)) {
              let reservationTime = value.replaceAll(":", "");
              if (reservationTime < rootComponent.checkStartTimeLimit || rootComponent.checkEndTimeLimit <= reservationTime) {
                return 'red-cell';
              }
            }

            let dupReservationDt = rootComponent.dupReservationDt;
            let reservationDate = utils.toStringByFormat(rowInfo.row.reservationDate, "YYYYMMDD");
            if (!utils.isEmpty(reservationDate) && !utils.isEmpty(value)) {
              let reservationDateTime = reservationDate + value.replaceAll(":", "");
              if (dupReservationDt.has(reservationDateTime)) {
                return 'orange-cell';
              }
            }
            return '';
          },

          component : {
            props : ['row','value','text'],
            template :`<span>{{text}}</span>`,
            computed : {
            },
            methods : {
            }
          },
          // 편집 모드일 때 사용하는 component
          editComponent : { 
            props : ['row','oriValue','text'], 
            template :'<aicc-time-picker @input="onTimeInput" v-model="timeValue" mode="stepper" :containMrdm="false" :anyEmptyAllEmpty="true" />',
            data(){
              return {
                timeValue : '' // 기본으로 보여질 시각
              }
            },
            mounted() {
              // 한 줄 추가하면 text는 undefined이다. 그때는 기본으로 보여질 시각으로 time picker를 설정한다.
              // 하지만, 한번 설정한 뒤에 편집 모드로 들어오면 앞서 설정한 시각이 text로 들어오므로 그때는 그 값을 time picker에 보이게 한다.
              if(this.text) {
                this.timeValue = this.text;
              }
            },
            computed : {
            },
            methods : {
              onTimeInput(value) {          
                //console.log('input', value);
                // 값을 바꿀 때마다 "시:분"을 예약 시각에 설정한다.
                // this.row.reservationTime = this.timeValue.substring(0, 5);
                // 아래와 같이 value에 값을 할당해야 emit("input", value)를 하고 edit component를 싸고 있는 cell에서 갖다 쓰게 된다.
                // 즉 editComponent 안에서 상위 component의 this.value를 쓸 수 있다
                this.value = value.substring(0, 5);                
                // 아래와 같이 해도 된다. (by uidev.help@samsung.com)
                // this.$emit('input', value.substring(0, 5))
              },
              getComponent(name) {
                  let component = null;
                  let thisComponent = this;
                  while(thisComponent && !component) {
                      if(thisComponent.$options.name === name) {
                          component = thisComponent;
                          break;
                      }
                      thisComponent = thisComponent.$parent;
                  }
                  return component;
              },
            }
          },
        },
        // __runScriptOrder
        {value: 'runScriptOrder', text: '대화ID 순서', width: 400, sort: true, filter:true,
        // {value: 'runScriptOrder', text: '대화ID 순서', width: auto, sort: true, filter:true,
          checker: (v, filter) => {
            // console.log('filter', filter)
            // '대화ID 순서 미지정' 칩 클릭시 filter는 빈 값을 갖는 Array 형태로 넘어온다.
            if (Array.isArray(filter)) {
              if (filter.length === 0) {
                return false;
              }
              for (let ii = 0; ii < filter.length; ii++) {              
                let filterData = filter[ii];
                if (utils.isEmpty(v)) {
                  return true;
                }
              }
            } else {
              // console.log('v', v, 'filter', filter, 'v.includes(filter)',v.includes(filter));
              if (!!v && v.includes(filter)) {
                  return true;
              }
            }
            return false; 
          },
          component :  { 
            props : ['row','value','text'], 
            template :`<span :class="backgroundColor">{{text}}</span>`,
            computed : {
              backgroundColor() {    
                if (utils.isEmpty(this.value)) {
                  // return 'background-color: #fff5e5'
                  return 'orange-cell';
                }      
                return '';
              }
            }
          },
          customClass: (value, rowInfo, callerComponent) => {
            let itemStatus = rowInfo.row.itemStatus;
            if(typeof itemStatus !== 'undefined' && !utils.isEmpty(itemStatus) && itemStatus !== 'A') {
              return 'grey-cell';
            }
          },
        },
        {value:'customerId', text: '고객ID', width: 200, key:true, required:false, sort: true, filter:true, 
          checker: (v, filter) => {
            // console.log(filter);
            if (Array.isArray(filter)) {
              if (filter.length === 0) {
                return false;
              }
              for (let ii = 0; ii < filter.length; ii++) {              
                let filterData = filter[ii];
                // console.log('v', v, 'filterData', filterData);
                if (!!v && v === filterData) {
                  return true;
                }
              }
            } else {
              // console.log('v', v, 'filter', filter);
              // console.log('v.includes(filter)',v.includes(filter))
              if (!!v && v.includes(filter)) {
                  return true;
              }
            }
            return false;        
          },          
          component :  { 
            props : ['row','value','text'], 
            template :`<p>{{text}}</p>`,
            computed : {
            }, 
            methods : {
            }
          },
          customClass: (value, rowInfo, callerComponent) => {
            let itemStatus = rowInfo.row.itemStatus;
            if(typeof itemStatus !== 'undefined' && !utils.isEmpty(itemStatus) && itemStatus !== 'A') {
              return 'grey-cell';
            }
          },
        },
        {value:'itemIndex', hide:true, text:'#', edit:false, readonly:true, width: 33,
          editComponent : {
              props : ['row','oriValue','text'], // provided by grid
              template :`<input type="text" readonly style="border: none; background-color: inherit;" v-model="value" />`
          }
        },
        {value:'itemStatus', hide:true, defaultValue: 'A'},
      ],

      csvDownLoadHeadersBase: [],
      csvDownLoadHeaders : [
        {value:'calleeNumber', text: this.$t('MSG_TXT_CALLEE_NUMBER1')},
        {value:'reservationDate', text: this.$t('MSG_TXT_RESERVATION_DATE')},
        {value:'reservationTime', text: this.$t('MSG_TXT_RESERVATION_TIME')},
        {value: 'runScriptOrder', text: '대화ID 순서', enclosingString: "\""},
        {value:'customerId', text: '고객ID'},
      ],
      csvDownloadDataSet: new urDataSet(),

      csvUploadCallees: [],
      csvUpload: false,

      dataSet : new urDataSet(),
      calleeOptions : {
          rowEdit : true,
          multiSelect: true,
          selectCheck: true,
          infinityScroll : true,
          height:240,
          clickMode: 'default',
          msgTotal: "총 #",
          msgBtnAdd : "추가",
          msgBtnDelete : "삭제",
          msgBtnModify : '수정',
          msgBtnSave : '저장',
          msgBtnCancel : '취소',
          msgAscending : '오름차순 정렬',
          msgDescending : '내림차순 정렬',
          msgSelectedCnt : "#개 선택됨",
          msgEmptyData : '',
          msgCalendarConfirm: '확인',
          msgCalendarToday: '오늘',
          msgValidRequired: '$는 필수입니다.',
      },

      heightNoChipMsg: 300,
      heightWithChipMsg: 280,
      
      calleeCustomColumns: [],
      calleeCustomColumnsForUpload: [],

      calleeTotalCnt: 0,

      calleeNumberTypeErrorCnt: 0,
      reservationDateTypeErrorCnt: 0,
      reservationTimeTypeErrorCnt: 0,
      periodDateFaultCnt: 0,
      periodTimeFaultCnt: 0,
      dupCalleeNumberCnt: 0,
      scriptOrderErrorCnt: 0,
      dupReservationDateCnt: 0,
      // dupReservationTimeCnt: 0,

      createdCallees: [],
      updatedCallees: [],
      removedCallees: [],
      
      uploadedCalleeList: [],

      // 수신리스트 추가나 수신인 클릭후 수정버튼 눌렀을때 체크된 행을 보관하기 위한 변수
      checkedCallee: [],

      showAllGuideMsg: false,
      showCalleeNumberTypeErrorMsg: false,
      showReservationDateTypeErrorMsg: false,
      showReservationTimeTypeErrorMsg: false,
      showPeriodDateFaultMsg: false,
      showPeriodTimeFaultMsg: false,      
      shoDupCalleeNumberMsg: false,
      showScriptOrderErrorMsg: false,      
      showDupReservationDateMsg: false,
      // showDupReservationTimeMsg: false,  
      showEmptyMsg: true,    

      filterList: {
        TypeError: [],
        periodFault: [],
        dupCalleeNumber: [],
        scriptOrder: [],
        dupReservationDateTime: [],
      },

      byteKeyScheduleName:0,
      byteKeyScheduleDescription:0,

      parseSubArrayDelimiter: '/',

      scenarioIdBotIdMap: new Map(),
      includeBeforeCurrentTimeReservation: false,

      timeLimitMsg: '',
      timeLimitError: false,

      copiedScheduleId: '',

      aiccWebSocket: '',

    };
  },

  computed: {
    gridHeight(){
        if(this.gridLength < 5) {
            return 240;
        }else if(this.gridLength > 9) {
            return 450;
        }
        else {
            return 49 * this.gridLength+48;
        }
    },
    gridOptions(){
      this.calleeOptions.height = this.gridHeight
      return this.calleeOptions;
    },
    aiccTimePickerClass(){
      let clazz = [];
      if(this.timeLimitError === true) {
        clazz.push('aicc-red-time-picker');
      }
      return clazz;
    },
    scheduleNameModel: {
      get() {
        // console.log('get['+this.scheduleNameValue+']')
        return this.scheduleNameValue;
      },
      set(newValue) {        
        // console.log('set['+newValue+']')
        this.scheduleNameValue = newValue;
        // console.log('set['+this.scheduleNameValue+']')
      }
    },

    diplaySipNumber() {
      let returnSipNumber = this.selectedSipNumber.split('|');
      let returnSipNumber0 = returnSipNumber[0].replace(/(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/, "$1-$2-$3")
      return returnSipNumber0 + ' ' + returnSipNumber[1];
    },

    dupCalleeNumber() {
      let result = new Set();
      let tempArray = Array.from(this.dupCalleeNumberSet);
      for(let index in tempArray) {
        result.add(tempArray[index]);
      }
      return result;
    },

    dupReservationDt() {
      let result = new Set();
      let tempArray = Array.from(this.dupReservationDtSet);
      for(let index in tempArray) {
        result.add(tempArray[index]);
      }
      return result;
    },

    ongoingScheduleCntInfo() {
      return utils.numberFormat(this.ongoingScheduleCnt);
    },

    calleeNumberTypeErrorCntInfo() {
      return utils.numberFormat(this.calleeNumberTypeErrorCnt);
    },

    reservationDateTypeErrorCntInfo() {
      return utils.numberFormat(this.reservationDateTypeErrorCnt);
    },

    reservationTimeTypeErrorCntInfo() {
      return utils.numberFormat(this.reservationTimeTypeErrorCnt);
    },

    periodDateFaultCntInfo() {
      return utils.numberFormat(this.periodDateFaultCnt);
    },

    periodTimeFaultCntInfo() {
      return utils.numberFormat(this.periodTimeFaultCnt);
    },

    dupCalleeNumberCntInfo() {
      return utils.numberFormat(this.dupCalleeNumberCnt);
    },

    scriptOrderErrorCntInfo() {
      return utils.numberFormat(this.scriptOrderErrorCnt);
    },

    dupReservationDateCntInfo() {
      return utils.numberFormat(this.dupReservationDateCnt);
    },

    enabledTemporaryButton() {
      // 임시저장 버튼은 Step1 캠페인 이름이나 시나리오, 상세설명 값 작성 시작되면 enable 한다.
      if (!utils.isEmpty(this.scheduleNameModel)) {
        return false;
      }
      if (!utils.isEmpty(this.selectedScenario)) {
        return false;
      }
      if (!utils.isEmpty(this.scheduleDescriptionValue)) {
        return false;
      }
      return true;
    },

  },

  watch: {
    isCancelCheck: function (newVal, oldVal) {
      // isCancelCheck 값이 true로 변했을 때 즉 newVal이 true일 때 
      // beforeunload 추가하고 false로 변했을 때 beforeunload 제거한다.
      if (newVal) {
        window.addEventListener('beforeunload', this.unLoadEvent);
      } else {
        window.removeEventListener('beforeunload', this.unLoadEvent);
      }
    },

  },

  created() {
    // this.debouncedGetScheduleName = _.debounce( function(scheduleId, scheduleNameValue) {
    //   this.existScheduleNameCheck(scheduleId, scheduleNameValue);
    // }, 500);

    // 캠페인 조회화면에서 수정모드나 복사모드로 호출되었는지 확인하여 해당 모드 flag 세팅한다.
    this.mode = utils.getParameter(this, 'mode');
    let scheduleId = utils.getParameter(this, 'scheduleId');

    if (this.mode === 'U' || this.mode === 'UB') {
      this.popupTitle = "캠페인 수정";
      // 캠페인 수정시 수정가능한 항목은 일정(이미 실행중인 건은 종료일정만), 번호, 콜 시도횟수로 제한
      // 'UB' 모드는 대기 상태 캠페인을 '임시저장'으로 변경하고 수정하는 경우로 업데이트시 '대기'로 바꿔야 한다.
      this.insertMode = false;
      this.updateMode = true;
      this.copyMode = false;
      this.outCallScheduleAsk.scheduleId = scheduleId;
      // 수정모드에서는 캠페인명 수정 불가능하여 동일여부 check 하지 않는다.
      this.scheduleNameCheckflag = true;

      // 수정모드는 다른 사용자 수정 방지를 위해 webSocket으로 세션 열고 getSchedule()를 한다.
      this.wsConnect();
      // this.getSchedule();

    } else if (this.mode === 'C') {
      this.insertMode = false;
      this.updateMode = false;
      this.copyMode = true;
      this.savedSchedule = {};
      this.copiedScheduleId = scheduleId;
      this.outCallScheduleAsk.scheduleId = scheduleId;
      this.getSchedule();
    } else {
      this.insertMode = true;
      this.updateMode = false;
      this.copyMode = false;
      this.updateData = {};
      this.outCallSchedule = {};

      // this.startDateValue = utils.toStringByFormat(utils.addDay(utils.now(),+1),'YYYY-MM-DD');
      // this.endDateValue = utils.toStringByFormat(utils.addDay(utils.now(),+1),'YYYY-MM-DD');

      this.startDateValue = utils.toStringByFormat(utils.now(),'YYYY-MM-DD');
      this.endDateValue = utils.toStringByFormat(utils.now(),'YYYY-MM-DD');

      this.dateRangeValue.push(this.startDateValue);
      this.dateRangeValue.push(this.endDateValue);
      this.startTimeLimitValue = '09:00';
      this.endTimeLimitValue = '18:00';
      this.setCheckScheduleDt();

      this.excludeSaturday = true;
      this.excludeSundayHoliday = true;

      this.getSipNumbersList();
      this.getScenarioList();
    }
  },

  mounted() {
    // console.log(JSON.stringify(this.checkScheduleInfo))
    this.$nextTick(() => {
      this.onLoad();
    });
  },

  beforeUpdate() {},

  updated() {},

  beforeUnmount() {
    // window.removeEventListener('beforeunload', this.unLoadEvent);
  },

  beforeDestroy() {},

  destroyed() {
    // 입력모드에서도 destroyed가 발생할 수 있어서 webSocket이 열려 있는지 체크함.
    if (this.aiccWebSocket) {
      this.wsDisconnect();
    }    
  },

  methods: {

    getByteSize(str) {
        let totalByte = 0;
        if(str) {
            for(let ii = 0 ; ii < str.length ; ii++) {
                const currChar = str.charAt(ii);
                const uniCurrChar = escape(currChar);
                if(uniCurrChar.length > 4) {
                    totalByte += 2;
                } else {
                    totalByte += 1;
                }
            }
        }
        return totalByte;
    },

    onLoad() {
      this.calleeHeadersBase = this.calleeHeaders;
      this.csvDownLoadHeadersBase = this.csvDownLoadHeaders;
      this.completeSaveFlag = false;
    },

    unLoadEvent(event) {
      event.preventDefault();
      event.returnValue = '';
    },

    // 캠페인 작성/수정창에서 '취소' 버튼 누른 경우 registerCancelModal을 띄운다.
    onClickRegisterCancel() {
      // 작성한 내용이 없으면 그냥 윈도우 close 한다.
      if (!this.isCancelCheck) {
        window.close();
      }
      // this.isCancelCheck이 true가 되는 순간 beforeunload 활성화 되기 때문에
      // registerCancelModal이 뜨는 경우는 해당 event를 제거한다.
      this.isCancelCheck = false;
      this.openRegisterCancelModal();
    },

    openRegisterCancelModal()  { 
      this.$refs.registerCancelModal.open(); 
    },

    // registerCancelModal이 뜬 상태에서 '취소' 버튼을 누른 경우
    onClickCancel() { 
      // registerCancelModal이 뜨는 순간 beforeunload 가 해제 되기 때문에
      // '취소' 버튼을 누르면 원래 대로 beforeunload를 활성화 시켜 놓는다.
      this.isCancelCheck = true;
      this.$refs.registerCancelModal.close();
    },

    // registerCancelModal이 뜬 상태에서 '확인' 버튼을 누른 경우
    onClickConfirm() {
      this.mode = this.mode + 'Cancel';
      this.sendOutCallInfoToParent();
      window.close();
    },

    // registerCancelModal이 뜬 상태에서 'X' 버튼을 누른 경우
    onCloseCancelModal() {
      console.log("RegisterCancelModal closed by onCloseCancelModal()");
    },

    onBlur(event) {
      this.scheduleNameValue = utils.trim(event.target.value);
      this.$nextTick(() => {
        this.$refs['refScheduleName'].validate();
      });
      if (!utils.isEmpty(this.scheduleNameValue)) {
        this.existScheduleNameCheck(this.savedSchedule.scheduleId, this.scheduleNameValue);  
      }
    },

    onClickAllChips() {
      // console.log("onClickAllChips")
      this.$refs['calleeGrid'].resetSelect();

      this.initializeChipMessageFlag();
      if (this.showAllGuideMsg) {
        this.showAllGuideMsg = false;
      } else {
        this.$refs['calleeGrid'].clearFilter();
        this.showAllGuideMsg = true;
      }
      this.calleeOptions.height = this.heightNoChipMsg;
    },

    onClickCalleeNumberTypeErrorChip() {
      this.$refs['calleeGrid'].clearFilter();
      this.$refs['calleeGrid'].resetSelect();
      if (this.showCalleeNumberTypeErrorMsg) {
        this.showCalleeNumberTypeErrorMsg = false;
        this.showAllGuideMsg = true;
        this.calleeOptions.height = this.heightNoChipMsg;
      } else {        
        if (this.calleeNumberTypeErrorCnt > 0) {
          this.showAllGuideMsg = false;
          this.initializeChipMessageFlag();
          this.showCalleeNumberTypeErrorMsg = true;
          
          this.calleeOptions.height = this.heightWithChipMsg;

          let calleeNumberFilter = [];
          let calleeNumberFilterData = [];

          this.filterList.typeError.forEach(filter => {
            if (filter.value === 'calleeNumber') {
              calleeNumberFilterData.push(filter.data);
            }
          });
          
          if (calleeNumberFilterData.length > 0) {
            calleeNumberFilter.push({value : 'calleeNumber', data: calleeNumberFilterData})
          }

          if (calleeNumberFilter.length > 0) {
            this.$refs['calleeGrid'].filter(calleeNumberFilter);
          }
        }
      }
    },

    onClickReservationDateTypeErrorChip() {
      this.$refs['calleeGrid'].clearFilter();
      this.$refs['calleeGrid'].resetSelect();
      if (this.showReservationDateTypeErrorMsg) {
        this.showReservationDateTypeErrorMsg = false;
        this.showAllGuideMsg = true;
        this.calleeOptions.height = this.heightNoChipMsg;
      } else {        
        if (this.reservationDateTypeErrorCnt > 0) {
          this.showAllGuideMsg = false;
          this.initializeChipMessageFlag();
          this.showReservationDateTypeErrorMsg = true;

          this.calleeOptions.height = this.heightWithChipMsg;

          let reservationDateFilter = [];
          let reservationDateFilterData = [];

          this.filterList.typeError.forEach(filter => {
            if (filter.value === 'reservationDate') {
              reservationDateFilterData.push(filter.data);
            }
          });

          if (reservationDateFilterData.length > 0) {
            reservationDateFilter.push({value : 'reservationDate', data: reservationDateFilterData})
          }

          if (reservationDateFilter.length > 0) {
            this.$refs['calleeGrid'].filter(reservationDateFilter);
          }
        }
      }
    },

    onClickReservationTimeTypeErrorChip() {
      this.$refs['calleeGrid'].clearFilter();
      this.$refs['calleeGrid'].resetSelect();
      if (this.showReservationTimeTypeErrorMsg) {
        this.showReservationTimeTypeErrorMsg = false;
        this.showAllGuideMsg = true;
        this.calleeOptions.height = this.heightNoChipMsg;
      } else {        
        if (this.reservationTimeTypeErrorCnt > 0) {
          this.showAllGuideMsg = false;
          this.initializeChipMessageFlag();
          this.showReservationTimeTypeErrorMsg = true;

          this.calleeOptions.height = this.heightWithChipMsg;
          
          let reservationTimeFilter = [];
          let reservationTimeFilterData = [];

          this.filterList.typeError.forEach(filter => {
            if (filter.value === 'reservationTime') {
              reservationTimeFilterData.push(filter.data);
            }
          });
 
          if (reservationTimeFilterData.length > 0) {
            reservationTimeFilter.push({value : 'reservationTime', data: reservationTimeFilterData})
          }

          if (reservationTimeFilter.length > 0) {
            this.$refs['calleeGrid'].filter(reservationTimeFilter);
          }

        }
      }
    },

    onClickPeriodDateFaultChip() {
      // console.log("onClickPeriodFaultChip")
      this.$refs['calleeGrid'].clearFilter();
      this.$refs['calleeGrid'].resetSelect();
      if (this.showPeriodDateFaultMsg) {
         this.showPeriodDateFaultMsg = false;
         this.showAllGuideMsg = true;
         this.calleeOptions.height = this.heightNoChipMsg;
      } else {
        if (this.periodDateFaultCnt > 0) {
          this.showAllGuideMsg = false;
          this.initializeChipMessageFlag();
          this.showPeriodDateFaultMsg = true;

          this.calleeOptions.height = this.heightWithChipMsg;

          let reservationDateFilter = [];
          let reservationDateFilterData = [];

          // console.log(this.filterList.periodFault)
          this.filterList.periodFault.forEach(filter => {
            if (filter.value === 'reservationDate') {
              reservationDateFilterData.push(filter.data);
            }
          });
          
          // console.log(reservationDateFilterData)
          if (reservationDateFilterData.length > 0) {
            reservationDateFilter.push({value : 'reservationDate', data: reservationDateFilterData})
          }

          // console.log(this.filterList.periodFault)
          if (reservationDateFilter.length > 0) {
            this.$refs['calleeGrid'].filter(reservationDateFilter);
          }
        }
      }
    },

    onClickPeriodTimeFaultChip() {
      // console.log("onClickPeriodFaultChip")
      this.$refs['calleeGrid'].clearFilter();
      this.$refs['calleeGrid'].resetSelect();
      if (this.showPeriodTimeFaultMsg) {
         this.showPeriodTimeFaultMsg = false;
         this.showAllGuideMsg = true;
         this.calleeOptions.height = this.heightNoChipMsg;
      } else {
        if (this.periodTimeFaultCnt > 0) {
          this.showAllGuideMsg = false;
          this.initializeChipMessageFlag();
          this.showPeriodTimeFaultMsg = true;

          this.calleeOptions.height = this.heightWithChipMsg;

          let reservationTimeFilter = [];
          let reservationTimeFilterData = [];
          this.filterList.periodFault.forEach(filter => {
            if (filter.value === 'reservationTime') {
              reservationTimeFilterData.push(filter.data);
            }
          });

          if (reservationTimeFilterData.length > 0) {
            reservationTimeFilter.push({value : 'reservationTime', data: reservationTimeFilterData})
          }

          if (reservationTimeFilter.length > 0) {
            this.$refs['calleeGrid'].filter(reservationTimeFilter);
          }

        }
      }
    },

    onClickDupCalleeNumberChip() {
      // console.log("onClickDupCalleeNumberChip")
      this.$refs['calleeGrid'].clearFilter();
      this.$refs['calleeGrid'].resetSelect();
      if (this.shoDupCalleeNumberMsg) {
        this.shoDupCalleeNumberMsg = false;
        this.showAllGuideMsg = true;
        this.calleeOptions.height = this.heightNoChipMsg;
      } else {
        if (this.dupCalleeNumberCnt > 0) {
          this.showAllGuideMsg = false;
          this.initializeChipMessageFlag();
          this.shoDupCalleeNumberMsg = true;

          this.calleeOptions.height = this.heightWithChipMsg;

          let calleeNumberFilter = [];
          let calleeNumberFilterData = [];

          this.filterList.dupCalleeNumber.forEach(filter => {
            if (filter.value === 'calleeNumber') {
              calleeNumberFilterData.push(filter.data);
            }
          });

          if (calleeNumberFilterData.length > 0) {
            calleeNumberFilter.push({value : 'calleeNumber', data: calleeNumberFilterData})
          }

          if (calleeNumberFilter.length > 0) {
            this.$refs['calleeGrid'].filter(calleeNumberFilter);
          }

        }
      }
    },

    onClickScriptOrderErrorChip() {
      // console.log("onClickScriptOrderErrorChip")
      this.$refs['calleeGrid'].clearFilter();
      this.$refs['calleeGrid'].resetSelect();
      if (this.showScriptOrderErrorMsg) {
        this.showScriptOrderErrorMsg = false;
        this.showAllGuideMsg = true;
        this.calleeOptions.height = this.heightNoChipMsg;
      } else {
        if (this.scriptOrderErrorCnt > 0) {
          this.showAllGuideMsg = false;
          this.initializeChipMessageFlag();
          this.showScriptOrderErrorMsg = true;

          this.calleeOptions.height = this.heightWithChipMsg;

          let scriptOrderFilter = [];
          let scriptOrderFilterData = [];

          this.filterList.scriptOrder.forEach(filter => {
            if (filter.value === 'runScriptOrder') {
              scriptOrderFilterData.push(filter.data);
            }
          });
          
          if (scriptOrderFilterData.length > 0) {
            scriptOrderFilter.push({value : 'runScriptOrder', data: scriptOrderFilterData})
            // console.log('runScriptOrder', scriptOrderFilter);
          }

          if (scriptOrderFilter.length > 0) {
            this.$refs['calleeGrid'].filter(scriptOrderFilter);
          }

        }
      }
    },

    onClickDupReservationDateChip() {
      // console.log("onClickDupReservationDateChip")
      this.$refs['calleeGrid'].clearFilter();
      this.$refs['calleeGrid'].resetSelect();
      if (this.showDupReservationDateMsg) {
        this.showDupReservationDateMsg = false;
        this.showAllGuideMsg = true;
        this.calleeOptions.height = this.heightNoChipMsg;
      } else {
        if (this.dupReservationDateCnt > 0) {
          this.showAllGuideMsg = false;
          this.initializeChipMessageFlag();
          this.showDupReservationDateMsg = true;

          this.calleeOptions.height = this.heightWithChipMsg;

          let reservationDateFilterData = [];
          let reservationTimeFilterData = [];

          // console.log("this.filterList.dupReservationDateTime", this.filterList.dupReservationDateTime)
          this.filterList.dupReservationDateTime.forEach(filter => {
            if (filter.value === 'reservationDate') {
              reservationDateFilterData.push(filter.data);
            }
            if (filter.value == 'reservationTime') {
              reservationTimeFilterData.push(filter.data);
            }
          });

          this.$refs['calleeGrid'].filter(
            [{value : 'reservationDate', data: reservationDateFilterData},
             {value : 'reservationTime', data: reservationTimeFilterData}]
          );

        }
      }
    },

    onClickDupReservationTimeChip() {

    },

    showSnackbar(message) {
      // 화면을 그리는 도중 message가 발생하는 경우가 있음 
      // 이 때 snackbar는 아직 객체화 되어 있지 않아 undefined 이므로
      // 화면 다 그리고 메시지를 보여주게 하려고 $nextTick()을 사용함.
      this.$nextTick(() => {
        this.$refs.snackbar.show({text: message});  
      });    
    },

    checkValidStep1ScheduleName() {
      // 스케쥴명을 입력할 때 마다 스케쥴명 중복 체크한다. => 실시간 중복 검사하지 않는다.
      // this.debouncedGetScheduleName(this.savedSchedule.scheduleId, this.scheduleNameValue);
      this.checkScheduleInfoForCancelModal();
    },

    checkValidStep1Scenario() {
      if (!utils.isEmpty(this.selectedScenario)) {
        this.onSelectedScenario(this.selectedScenario);
      }
      this.checkValidStep1();
      this.checkScheduleInfoForCancelModal();
    },

    checkValidStep1ScheduleDescription() {
      this.checkValidStep1();
      this.checkScheduleInfoForCancelModal();
    },

    checkValidStep1() {
      // step0 의 Validation check 한다.
      this.steps[0].valid = this.setValidStep1();
    },

    setValidStep1() {
      return aiccUtils.getStringByteSize(this.scheduleNameValue) <= this.maxScheduleNameLength &&
          aiccUtils.getStringByteSize(this.scheduleDescriptionValue) <= this.maxScheduleDescriptionLength &&
          !utils.isEmpty(this.scheduleNameValue) && this.scheduleNameCheckflag && !utils.isEmpty(this.selectedScenario);
    },

    checkValidStep2() {
      this.steps[1].valid = false;

      // 입력모드, 복사모드, 진행중 상태 수정모드인 경우 시간 체크 한다.
      // 진행중을 제외한 수정모드는 일자, 시간이 비활성화 되어 있기 때문에 시간 체크하지 않는다.
      // 수정 모드인 경우도 작성중, 대기인 경우 수행일정 수정 가능하다.
      if (this.insertMode || this.copyMode || (this.updateMode && this.outCallSchedule.scheduleStatus === 'C') ||
         (this.updateMode && (this.outCallSchedule.scheduleStatus === 'A' || this.outCallSchedule.scheduleStatus ==='B'))) {

        if (!utils.isEmpty(this.dateRangeValue[0]) || !utils.isEmpty(this.dateRangeValue[1])) {
          this.steps[1].valid = this.onInputDateCheck();
          if (!this.steps[1].valid) {
            return;
          }
        }

        if (!utils.isEmpty(this.startTimeLimitValue) || !utils.isEmpty(this.endTimeLimitValue)) {
          this.steps[1].valid = this.onInputTimeCheck();
          if (!this.steps[1].valid) {
            return;
          }
        }

      }

      if (!utils.isEmpty(this.selectedSipNumber)) {
        this.onSelectedSipNumber(this.selectedSipNumber);
      } else {
        
        if (this.stepIndex === 2) {
          this.showSnackbar('발신번호를 선택하세요.');
          this.steps[1].valid = false;
          return;
        }
      }

      this.checkScheduleInfoForCancelModal();
      this.steps[1].valid = true;
    },

    checkValidStep3() {
      this.steps[2].valid = true;
      if (this.calleeTotalCnt === 0) {
        this.steps[2].valid = false;
        return;
      }
      if (this.calleeNumberTypeErrorCnt > 0 || this.reservationDateTypeErrorCnt > 0 || this.reservationTimeTypeErrorCnt > 0 || 
          this.periodDateFaultCnt > 0 || this.periodTimeFaultCnt > 0) {
        this.steps[2].valid = false;
        return;
      }      
    },

    onCheckBeforeStepMove() {
      let stepValid = false;
      // (1) 수행일정이 오늘을 포함할 경우, 현재시간 < 종료시간이어야 함
      // : 수행일정이 오늘을 포함하고 있는데, 종료시간이 현재시간보다 같거나 작을 경우 "다음" 버튼을 누르면
      //   모달 얼럿 "현재 수행 가능하지 않은 일정을 포함하고 있습니다. [확인]" 노출 및 다음으로 넘어가지 않고 Step2. 페이지 유지
      let endTime = this.convertTimeLimit(this.endTimeLimitValue);
      if ((this.startDateValue === this.getTodayYmd() || this.endDateValue === this.getTodayYmd()) && 
          (endTime <= this.getTodayHHmm().replaceAll(":",""))) {
          utils.aiccMessageBox('알림', '현재 수행 가능하지 않은 일정을 포함하고 있습니다.', 
            '확인', () => {
              this.steps[1].valid = false;
            }, null, null);
      } else {
        stepValid = true;
      }
      return stepValid;
    },

    onMoveStep(index) {
      // stepIndex 는 다른 함수에서 사용하기 위해 세팅한다.
      this.stepIndex = index + 1;

      // 입력한 값을 그대로 둔 채 이전, 다음 버튼을 누를 수 있으니 여기서 valid check를 한번 더 한다.
      if (index === 0) {
        this.checkValidStep1();
      }
      if (index === 1) {
        this.checkValidStep2();
      }
      if (index === 2) {
        this.checkValidStep3();
      }
    },

    onClickNext() {
      
    },

    onClickPrev() {

    },

    onClickOngingPopup() {
      this.$refs['ongoingModal'].open();
    },

    onCloseOngoingPopup() {
      console.log('pagePopup.onCloseOngoingPopup() was called.');
    },

    onInputDateCheck() {
      this.startDateValue = this.dateRangeValue[0];
      this.endDateValue = this.dateRangeValue[1];

      if (utils.isEmpty(this.startDateValue)) {
        this.showSnackbar('시작일자가 빈 값입니다.');
        return false;
      }
      if (utils.isEmpty(this.endDateValue)) {
        this.showSnackbar('종료일자가 빈 값입니다.');
        return false;
      }
      if (utils.compareTo(this.startDateValue, this.getTodayYmd()) < 0) {
        this.showSnackbar('시작일자가 오늘일자 보다 작습니다.');
        return false;
      }
      if (utils.compareTo(this.endDateValue, this.getTodayYmd()) < 0) {
        this.showSnackbar('종료일자가 오늘일자 보다 작습니다.');
        return false;
      }
      // if (utils.compareTo(this.endDateValue, this.startDateValue) < 0) {
      //   this.showSnackbar('종료일자가 시작일자 보다 작습니다.');
      //   return;
      // }
      this.setCheckScheduleDt();

      // 날짜가 변경되었으니 수신인리스트 validation을 수행한다.
      // Data grid에 데이터를 다시 밀어 넣어줘야 헤더에서 정의한 validation Rule이 적용된다.
      // => setData 하는 경우 수신리스트 변경사항(created, updated, removed)가 모두 초기화되어 헤더 정의시 component -> customClass 방식으로 변경함.
      this.$nextTick(() => {
      //   if (this.$refs['calleeGrid'].getData().length > 0) {
          // let calleeList = [];
          // calleeList = this.$refs['calleeGrid'].getData();
          // this.$refs['calleeGrid'].initGrid();
          // this.dataSet.setData(calleeList);
          this.validationCalleeList();
      //   }
      });

      return true;
    },

    onInputTimeCheck() {
      this.timeLimitMsg = '';
      this.timeLimitError = false;

      let startTime = this.convertTimeLimit(this.startTimeLimitValue);
      let endTime = this.convertTimeLimit(this.endTimeLimitValue);

      if (endTime <= startTime) {
        this.timeLimitMsg = '종료시각이 시작시각보다 작거나 같습니다.';
        this.timeLimitError = true;
        return false;
      }

      this.setCheckScheduleDt();

      // 시간이 변경되었으니 수신인리스트 validation을 수행한다.
      // Data grid에 데이터를 다시 밀어 넣어줘야 헤더에서 정의한 validation Rule이 적용된다.
      // => setData 하는 경우 수신리스트 변경사항(created, updated, removed)가 모두 초기화되어 헤더 정의시 component -> customClass 방식으로 변경함.
      this.$nextTick(() => {
      //   if (this.$refs['calleeGrid'].getData().length > 0) {
          // let calleeList = [];
          // calleeList = this.$refs['calleeGrid'].getData();
          // this.$refs['calleeGrid'].initGrid();
          // this.dataSet.setData(calleeList);
          this.validationCalleeList();
      //   }
      });  
      return true;
    },

    onSelectedSipNumber(seletedOption) {
      this.selectedSipNumber = seletedOption;
      let optionArr = seletedOption.split("|");
      this.getOngoingSchedule(optionArr[0]);
    },

    onSelectedScenario(seletedOption) {
      this.selectedScenario = seletedOption;
      utils.forEach(this.selectScenarioOptions, scenarioOption => {
        if (scenarioOption.value === seletedOption) {
          this.selectedScenarioName = scenarioOption.text;
        }
      });

      // 수정모드에서 작성중, 대기중 이외는 시나리오 변경하지 않으니 onSelectedScenario에서 scenarioVariable을 다시 가져올 필요 없다.
      if (this.updateMode && this.outCallSchedule.scheduleStatus !== 'A' && this.outCallSchedule.scheduleStatus !=='B') {
        return;
      }
      // console.log("onSelectedScenario", this.selectedScenario)
      let selectedScenarioArr = this.selectedScenario.split("|")
      this.getScenarioVariable(selectedScenarioArr[0], '');
    },

    onChangeRetryCount() {
      if (this.selectedRetryCount > 1) {
        this.showRetryInterval = true;
      } else {
        this.showRetryInterval = false;
      }
      if (!utils.isEmpty(this.checkScheduleInfo.selectedRetryCount)) {
        this.checkScheduleInfoForCancelModal();
      }
    },

    onCalleeDataChanged(row) {
      // {created: Array(0), updated: Array(0), removed: Array(0)}
      // console.log('onCalleeDataChanged', row);

      // 화면이 처음 열릴 때에도 onCalleeDataChanged()가 호출되어 this.$nextTick 을 사용함
      // 수신리스트에서 작업한 내용이 없더라도 뭔가 있는 상태가 있을 수 있으므로 validationCalleeList 를 수행한다.
      this.$nextTick(() => {
        this.initializeChipMessageFlag();
        this.validationCalleeList();        
        if (this.showAllGuideMsg) {
          this.showAllGuideMsg = false;
          this.onClickAllChips();
        }
      });

      // 수신리스트에서 작업한 내용이 없으면 그냥 돌아간다.
      // 두 건 추가했다가 바로 추가한 건을 삭제하면 row.created 는 비어 있으나 this.createdCallees 는 두 건 남아 있게 된다.
      // 그래서 this.createdCallees 변수들을 초기화 한다.
      if (row.created.length === 0 && row.updated.length === 0 && row.removed.length === 0) {
        this.createdCallees = [];
        this.updatedCallees = [];
        this.removedCallees = [];
        return;
      }

      // 수신리스트에서 뭔가 작업한 내용이 있으니 '취소' 클릭시 레이어 팝업을 띄워야 한다.
      this.isCancelCheck = true;

      // 수신리스트에서 작업한 내용을 각각 배열에 넣어 둔다.
      this.createdCallees = row.created;
      this.updatedCallees = row.updated;
      this.removedCallees = row.removed;

    },

    onCalleeAdd() {
      // console.log('onCalleeAdd')
      this.gridLength = this.$refs['calleeGrid'].getDataSet().getRawData().length+1;
      this.$refs['calleeGrid'].resetSelect();
      let firstRow = this.dataSet.getViewData()[0];
      this.dataSet.setSelect(firstRow);
      
      // let rows = this.dataSet.getViewData();
      // for(let ii = 0; ii < rows.length; ii++) {
      //   console.log('onCalleeAdd row selected', rows[ii].__selected);
      // }

      // 첫번째 행이 체크된 상태이므로 checkedCallee에 첫번째 행을 넣어둔다.
      this.checkedCallee = [];
      this.checkedCallee.push(firstRow)
      // console.log('onCalleeAdd checkedCallee', this.checkedCallee)

      this.showEmptyMsg = false;
    },

    onCalleeModify() {
      // console.log('onCalleeModify')
      // console.log('this.dataSet.getViewData()', this.dataSet.getViewData())

      // 특정 행을 선택한 다음 수정 버튼을 누른 경우 checkedCallee에 특정 행을 넣어둔다.
      // 두개 이상 행을 선택하면 수정 버튼이 비활성화 되기 때문에 수정 버튼을 누른 경우 선택한 행은 항상 1개이다.
      let rows = this.dataSet.getViewData();
      for(let ii = 0; ii < rows.length; ii++) {
        // console.log('onCalleeAdd row selected', rows[ii].__selected);
        if (rows[ii].__selected) {
          this.checkedCallee.push(rows[ii]);
          break;
        }
      }
      // console.log('onCalleeModify checkedCallee', this.checkedCallee)
    },

    onCalleeSave(row) {
      // console.log('onCalleeSave')
      this.$refs['calleeGrid'].resetSelect();
      // Chip 필터를 선택한 후 수정하고 저장하는 경우가 있어서 필터 초기화를 위해 initGrid() 한다.
      this.$refs['calleeGrid'].initGrid();
      // 수신인 추가나 수정 버튼을 누르는 경우 선택된 행을 보관하는 변수를 초기화 한다.
      this.checkedCallee = [];
    },

    onCalleeClick(cell, row, field, e) {
      // console.log('onCalleeClick', row)
      // 수신리스트 row를 클긱하여 check box 선택 해제하면 row.__selected는 false 인 상태로 이쪽으로 온다.
      // checkCalleeEditable 수행하여 원래 calleeOption으로 다시 세팅한다.
      this.checkCalleeEditable(row);
    },

    onCalleeSelected(rows) {
      // console.log('onCalleeSelected', rows)
      if (utils.isEmpty(rows)) {
         this.$nextTick(()=>{ this.$refs['calleeGrid'].updateOptions(this.calleeOptions);});
        return;
      }
      this.checkCalleeEditable(rows);
    },

    onCalleeDelete(row) {
      // console.log('onCalleeDelete', row)
      this.$refs['calleeGrid'].initGrid();
      this.gridLength = this.$refs['calleeGrid'].getDataSet().getRawData().length;
      this.validationCalleeList();
      this.initializeChipMessageFlag();

      // 수신인 추가나 수정 버튼을 누르는 경우 선택된 행을 보관하는 변수를 초기화 한다.
      this.checkedCallee = [];

      if (this.$refs['calleeGrid'].getDataSet().getRawData().length > 0) {
        this.showEmptyMsg = false;
      } else {
        this.showEmptyMsg = true
      }
    },

    onCheckClick(rows) {
      // console.log("onCheckClick", rows)
      // console.log('onCheckClick checkedCallee', this.checkedCallee)

      // 수신인 추가나 수정버튼 클릭시 선택된 수신인은 checkedCallee에 담겨 있다.
      // 체크박스 클릭시 선택된 행은 그대로 선택된 상태, 선택되지 않은 행은 선택되지 않는 상태로 남겨 두기 위해 
      // resetSelect 한 후 선택된 행만 setSelect 한다.
      if (this.checkedCallee.length > 0) {
        this.$refs['calleeGrid'].resetSelect();
        // console.log('this.checkedCallee[0]', this.checkedCallee[0])
        this.dataSet.setSelect(this.checkedCallee[0]);
      }

      // 수신 리스트 check box 클릭하여 선택 해제하면 rows는 빈값이 된다.
      // checkCalleeEditable 수행하여 원래 calleeOption으로 다시 세팅한다.
      this.checkCalleeEditable(rows);
    },

    onFilterChanged(filter) {
             
    },

    onCalleeCancel() {
      // console.log('onCalleeCancel')
      this.$refs['calleeGrid'].initGrid();
      this.gridLength = this.$refs['calleeGrid'].getDataSet().getRawData().length;
      // 수신인 추가나 수정 버튼을 누르는 경우 선택된 행을 보관하는 변수를 초기화 한다.
      this.checkedCallee = [];

      // 필터칩이 선택된 경우라면 선택된 리스트를 유지시킨다.
      if (this.showCalleeNumberTypeErrorMsg) {
        this.showCalleeNumberTypeErrorMsg = false;
        this.onClickCalleeNumberTypeErrorChip();
      }      
      if (this.showReservationDateTypeErrorMsg) {
        this.showReservationDateTypeErrorMsg = false;
        this.onClickReservationDateTypeErrorChip();
      }
      if (this.showReservationTimeTypeErrorMsg) {
        this.showReservationTimeTypeErrorMsg = false;
        this.onClickReservationTimeTypeErrorChip();
      }  
      if (this.showPeriodDateFaultMsg) {
        this.showPeriodDateFaultMsg = false;
        this.onClickPeriodDateFaultChip();
      }
      if (this.showPeriodTimeFaultMsg) {
        this.showPeriodTimeFaultMsg = false;
        this.onClickPeriodTimeFaultChip();
      }
      if (this.shoDupCalleeNumberMsg) {
        this.shoDupCalleeNumberMsg = false;
        this.onClickDupCalleeNumberChip();
      }
      if (this.showScriptOrderErrorMsg) {
        this.showScriptOrderErrorMsg = false;
        this.onClickScriptOrderErrorChip();
      }
      if (this.showDupReservationDateMsg) {
        this.showDupReservationDateMsg = false;
        this.onClickDupReservationDateChip();
      }
      
      if (this.$refs['calleeGrid'].getDataSet().getRawData().length > 0) {
        this.showEmptyMsg = false;
      } else {
        this.showEmptyMsg = true
      }
    },

    checkCalleeEditable(rows) {      
      // 수정모드인 경우 아웃바운드 진행된 수신인은 수정이나 삭제할 수 없음
      let itemStatus;
      let nonselectableSelected = false;
      for(let ii = 0; ii < rows.length; ii++) {
        itemStatus = rows[ii].itemStatus;
        if(typeof itemStatus !== 'undefined' && !utils.isEmpty(itemStatus) && rows[ii].__selected && itemStatus !== 'A') {
          // 아이템 상태가 대기중이 아닌 게 선택돼서 섞여있다. 즉 진행중이거나 종료된 것은 편집하지 못하게 해야 한다.
          nonselectableSelected = true;
          break;
        }
      }

      // console.log("nonselectableSelected", nonselectableSelected)

      // 수정모드인 경우 아웃바운드 진행된 수신인은 수정이나 삭제할 수 없음
      if (this.updateMode && nonselectableSelected) {
        this.showSnackbar('아웃바운드 콜이 진행 중이거나 종료된 수신인은 수정이나 삭제할 수 없습니다.');
        this.calleeOptions.rowEdit = false;
        // this.$refs['calleeGrid'].updateOptions(this.calleeOptionsNotEditable);
      } 
      else {
        this.calleeOptions.rowEdit = true;
        // this.$refs['calleeGrid'].updateOptions(this.calleeOptions);
      }
      // console.log("this.calleeOptions", this.calleeOptions)
       this.$nextTick(()=>{ this.$refs['calleeGrid'].updateOptions(this.calleeOptions);});
    },

    onClickTempSave() {
     Promise.all([
      ]).then(() => {
        // Step1, Step2 에서도 '임시저장' 누를 수 있으므로 각 단계에 에러 있는지 체크한다.
        if (!this.steps[0].valid) {
            this.showSnackbar('캠페인 이름, 시나리오 등 필수 입력값 오류 없는지 확인해주시기 바랍니다.');
            return;
        }
        if (!this.steps[1].valid) {
            this.showSnackbar('수행일정, 수행시간 등 필수 입력값 오류 없는지 확인해주시기 바랍니다.');
            return;
        }
        if (!this.steps[2].valid) {
            this.showSnackbar('수신리스트가 비어 있거나 오류 없는지 확인해주시기 바랍니다.');
            return;
        }

        // 중지(E)를 제외한 캠페인은 임시저장 버튼 클릭시 캠페인 상태를 임시저장(A)으로 한다.
        if (this.outCallSchedule.scheduleStatus !== 'E') {
          this.outCallSchedule.scheduleStatus = 'A';
        }
        this.onCheckBeforeCampaignSave();
      });
    },

    onClickComplete() {
      // console.log("Complete step proc.");
      if (this.$refs.calleeGrid.getData().length === 0) {
        this.showSnackbar('저장 완료하려면 수신번호를 하나 이상 입력해야 합니다.');
        return;
      }
      // 완료 버튼 클릭시 캠페인 Status 는 대기(B)
      this.completeSaveFlag = true;
      this.onCheckBeforeCampaignSave();
    },

    onCheckBeforeCampaignSave() {
      // 데이터 형식, 예약일자 오류 있는지 체크
      if (this.calleeNumberTypeErrorCnt > 0 || this.reservationDateTypeErrorCnt > 0 || this.reservationTimeTypeErrorCnt > 0 || 
          this.periodDateFaultCnt > 0 || this.periodTimeFaultCnt > 0) {
        this.showSnackbar('수신리스트 오류 수정이 필요합니다.');
        return false;
      }
      
      // 신규 캠페인 작성, 작성중/대기중/중지 캠페인의 수정
      // Step3. 수신리스트에서 내용작성 후 [임시저장/완료]버튼 클릭 시 수행하는 기존의 유효성 체크에 다음 내용 추가      
      // 수신리스트 내 전 행의 예약일자+시간 조합을 확인하여, 다음의 얼럿노출대상 케이스 발생 시
      // 얼럿 "현재일시 이전의 예약일자/시간 지정 건이 있습니다. 캠페인 진행 시 해당 건을 가장 먼저 수행합니다. [취소/확인]" 노출
      // >>얼럿노출대상1. 현재일시 >= 예약일자+시간 조합이 존재
      // >>얼럿노출대상2. 캠페인 총 기간이 오늘 1일이면서 (from 오늘 to 오늘) && 현재시간 >= 예약시간인 경우
      if (this.includeBeforeCurrentTimeReservation) {
        utils.aiccMessageBox('알림', '현재일시 이전의 예약일자/시간 지정 건이 있습니다. 캠페인 진행 시 해당 건을 가장 먼저 수행합니다.', 
          '확인', () => {         
            this.onCampaignSave();      
          }, 
          '취소', () => {
            return;
          }
        );
      } else {
        this.onCampaignSave(); 
      }

    },

    onCampaignSave() {
      this.outCallSchedule.scheduleName = this.scheduleNameValue;
      this.outCallSchedule.scheduleDescription = this.scheduleDescriptionValue;

      // 중지(E) 캠페인 수정시 상태를 그대로 유지한다.
      if (this.updateMode && this.outCallSchedule.scheduleStatus === 'E') {
        this.outCallSchedule.scheduleStatus = 'E';
      } else {
        // 'UB' 모드는 대기 캠페인을 임시저장(A)으로 변경하고 수정하는 경우로서 '대기(B)'로 다시 바꿔 놓아야 한다.
        if (this.completeSaveFlag || this.mode === 'UB') {
          this.outCallSchedule.scheduleStatus = 'B';
        } else {
          this.outCallSchedule.scheduleStatus = 'A';
        }
      }

      // console.log('this.updateMode', this.updateMode)
      // console.log('this.outCallSchedule.scheduleStatus', this.outCallSchedule.scheduleStatus)

      // 수행일자, 수행시간 변환
      this.startDateValue = this.dateRangeValue[0];
      this.endDateValue = this.dateRangeValue[1];
      this.outCallSchedule.startDate = utils.toStringByFormat(utils.toDate(this.startDateValue), 'YYYYMMDD');
      this.outCallSchedule.startTimeLimit = this.convertTimeLimit(this.startTimeLimitValue);
      this.outCallSchedule.endDate = utils.toStringByFormat(utils.toDate(this.endDateValue), 'YYYYMMDD');
      this.outCallSchedule.endTimeLimit = this.convertTimeLimit(this.endTimeLimitValue);

      // 제외옵션 설정
      this.outCallSchedule.excludeHolidayYn = 'N';
      if (this.excludeSundayHoliday) {
        this.outCallSchedule.excludeHolidayYn = 'Y';
      }
      this.outCallSchedule.excludeDayofweek = ''
      if (this.excludeSundayHoliday && !this.excludeSaturday) {
        this.outCallSchedule.excludeDayofweek = this.SUNDAY;
      }
      if (!this.excludeSundayHoliday && this.excludeSaturday) {
        this.outCallSchedule.excludeDayofweek = this.SATURDAY;
      }
      if (this.excludeSundayHoliday && this.excludeSaturday) {
        this.outCallSchedule.excludeDayofweek = this.SUNDAY + "," + this.SATURDAY;
      }

      // sipNumber, callerId
      let sipNumberCallerId = this.selectedSipNumber.split('|');
      this.outCallSchedule.sipNumber = sipNumberCallerId[0].replaceAll('-','');
      this.outCallSchedule.callerId = sipNumberCallerId[2];
      // this.outCallSchedule.callerId = sipNumberCallerId[1];
      if (this.outCallSchedule.callerId === '-') {
        this.outCallSchedule.callerId = null;
      }        

      this.outCallSchedule.scenarioId = this.selectedScenario;
      this.outCallSchedule.botId = this.scenarioIdBotIdMap.get(this.selectedScenario);

      // 콜 시도 횟수 1이라는 의미는 1번만 콜 한다는 것으로 retry 하지 않는다는 뜻이다.
      // 따라서 retryNumber는 콜 시도 횟수에서 -1 한다.
      this.outCallSchedule.retryNumber = this.selectedRetryCount - 1;

      // 콜 시도 우선순위
      if (this.outCallSchedule.retryNumber > 0) {
        this.outCallSchedule.retryInterval = this.selectedRetryInterval;
      } else {
        this.outCallSchedule.retryInterval = '';
      }      

      // userId, tenantId 는 서버에서 session 정보를 읽어 setting 한다.

      this.setCalleeListForSave();

      if (this.temporarySavedFlag || this.updateMode) {
        // '임시저장'으로 한번이라도 저장했거나 수정 모드이면 업데이트로 처리
        this.outCallSchedule.isInsert = "N";
        this.outCallSchedule.isUpdate = "Y";
        this.outCallSchedule.isUpload = "N";
      } else {
        // 입력모드나 복사모드는 입력으로 처리
        this.outCallSchedule.isInsert = "Y";
        this.outCallSchedule.isUpdate = "N";
        this.outCallSchedule.isUpload = "N";
      }
      if (this.csvUpload) {
        this.outCallSchedule.isInsert = "N";
        this.outCallSchedule.isUpdate = "N";
        this.outCallSchedule.isUpload = "Y";
      }

      this.sendOutCallInfoToParent();

      // '임시저장'으로 한번이라도 저장했거나 수정 모드이면 업데이트로 처리
      if (this.temporarySavedFlag || this.updateMode) {
        // console.log(JSON.stringify(this.outCallSchedule));
        this.outCallSchedule.isUpdate = "Y";
        utils.aiccMessageBox('확인', this.$t('MSG_ALT_WANT_SAVE'), 
          '확인', () => {

          // '완료' 클릭시는 저장하고 목록화면으로 돌아가기 때문에 cancel 여부를 체크하지 않는다.
          // update 작업 이후 flag를 세팅하게 되어 있으나 DB update와 시간차 때문에 여기서 미리 세팅한다.
          if (this.completeSaveFlag) {
            this.isCancelCheck = false;
          }

          http.request(this.$options.name, 'DTS_AIC_00009', {
            data: this.outCallSchedule,
            }).then((response) => {
              if (response.data.reply.code !== "0000") {
                this.showSnackbar(response.data.reply.korMsg);
              } else {

                this.setSavedSchedule(this.outCallSchedule);
                this.initializeCalleeArrays();

                // getScenarioVariable를 호출하여 custom 헤더 정보를 callee 헤더에 더한 다음 수신인 정보를 가져온다.
                this.getScenarioVariable(this.outCallSchedule.scenarioId, this.outCallSchedule.scheduleId);

                if (this.outCallSchedule.scheduleStatus == 'A') {                  
                  this.showSnackbar(utils.strFormat('임시저장되었습니다. \n캠페인을 실행하려면 등록을 완료해주세요.'));
                } else {
                  this.showSnackbar('수정되었습니다.');
                }
                
                this.temporarySavedFlag = true;
                // csvUpload 후 한번이라도 저장했으므로 더 이상 csvUpload로 처리하지 않는다.
                this.csvUpload = false;
                this.isCancelCheck = false;

                // '완료'시 캠페인 리스트 화면('PGE_AIC_00004')으로 돌아간다.
                // console.log('this.completeSaveFlag ', this.completeSaveFlag)
                if (this.completeSaveFlag) {
                  // this.$store.commit('oucallScheudle', this.outCallSchedule)
                  window.close();
                }

              }
            }).catch((error) => {
              console.warn(error);
            });
          },
          '취소', this.onClickMessageBoxCancel(),
          'small',
        );

      // 입력모드나 복사모드면 입력으로 처리
      } else {      
        // console.log(JSON.stringify(this.outCallSchedule));
        this.outCallSchedule.scheduleId = '';
        this.outCallSchedule.isInsert = "Y";
        utils.aiccMessageBox('확인', this.$t('MSG_ALT_WANT_SAVE'), 
          '확인', () => {

          // '완료' 클릭시는 저장하고 목록화면으로 돌아가기 때문에 cancel 여부를 체크하지 않는다.
          // insert 작업 이후 flag를 세팅하게 되어 있으나 DB insert와 시간차 때문에 여기서 미리 세팅한다.
          if (this.completeSaveFlag) {
            this.isCancelCheck = false;
          }

          http.request(this.$options.name, 'DTS_AIC_00003', {
            data: this.outCallSchedule,
            }).then((response) => {
              if (response.data.reply.code !== "0000") {
                this.showSnackbar(response.data.reply.korMsg);
              } else {              
                // 입력시 발급된 scheduleId을 outCallSchedule에 넣어둔다.
                this.outCallSchedule.scheduleId = response.data.scheduleId;
                // 저장된 정보를 백업해 둔다.
                
                this.setSavedSchedule(this.outCallSchedule);
                this.initializeCalleeArrays();

                // getScenarioVariable를 호출하여 custom 헤더 정보를 callee 헤더에 더한 다음 수신인 정보를 가져온다.
                this.getScenarioVariable(this.outCallSchedule.scenarioId, this.outCallSchedule.scheduleId);

                if (this.outCallSchedule.scheduleStatus == 'A') {                  
                  this.showSnackbar(utils.strFormat('임시저장되었습니다. \n캠페인을 실행하려면 등록을 완료해주세요.'));
                } else {
                  this.showSnackbar('저장되었습니다.');
                }

                this.temporarySavedFlag = true;
                // csvUpload 후 한번이라도 저장했으므로 더 이상 csvUpload로 처리하지 않는다.
                this.csvUpload = false;
                this.isCancelCheck = false;

                // '완료'시 캠페인 리스트 화면('PGE_AIC_00004')으로 돌아간다.
                if (this.completeSaveFlag) {
                  // this.$store.commit('oucallScheudle', this.outCallSchedule)
                  window.close();
                }

              }
            }).catch((error) => {
              console.warn(error);
            });
          },
          '취소', this.onClickMessageBoxCancel()
        );

      }
    },

    onClickMessageBoxCancel() {
      console.log('onClickMessageBoxCancel() was called.')
    },

    setCalleeListForSave() {
      // itemIndex 제어를 위한 변수
      let itemIndex = 0;
      if (this.calleeMaxItemIndex > 0) {
        itemIndex = this.calleeMaxItemIndex;
      }

      // 복사 모드와 csv 업로드한 경우 화면에서 작업한 결과를 createdCallees에 넣는다.
      // 복사 모드의 경우 한번이라도 임시 저장했으면 수정모드처럼 처리한다.
      // csv 업로드한 경우 임시 저장을 하더라도 다시 올릴 수 있으니 createdCallees에 넣는다.
      this.outCallSchedule.createdCallees = [];
      if ((!this.temporarySavedFlag && this.copyMode) || this.csvUpload) {

        // 복사 모드와 csv 업로드 경우 최초 저장시 itemIndex 값을 1번부터 부여한다.
        // 부여 기준은 복사되거나 업로드된 것부터 넘버링하고 새로 추가한 것들은 그 이후 번호를 부여한다.
        // 새로 추가한 것들의 itemIndex는 비어 있는 상태로 나중에 넣은 것이 위에 있게 되므로 역순으로 번호를 부여한다.
        
        // 만일 수신인 3개 짜리를 복사하거나 업로드 했을 때
        // 화면에 itemIndex가 1, 2, 3으로 보였을 것이고 이 중 2번을 삭제하고 새로 두 건을 추가했다면
        // 화면에는 빈값, 빈값, 1, 3으로 보이게 된다.
        // 이 경우 최초 저장시 itemIndex 값은 4, 3, 1, 2 가 된다.

        // itemIndex 값을 0으로 만든다.
        if (itemIndex > 0) {
          itemIndex = 0;
        };

        // 복사나 업로드 된 것 부터 넘버링한다.
        for (let callee of this.$refs['calleeGrid'].getData()) {
          if (!utils.isEmpty(callee.itemIndex)) {
            itemIndex++;
            callee.itemIndex = itemIndex;
            let obj = this.setCalleeItem(callee);
            this.outCallSchedule.createdCallees.push(obj);
          }          
        }

        // 새로 추가된 것을 역순으로 넘버링하기 위해 수신인 갯수를 구한다.
        let calleeCnt = this.$refs.calleeGrid.getData().length;
        // console.log("calleeCnt ", calleeCnt);

        // 새로 입력한 것들은 itemIndex 가 빈 값인 상태이다.
        for (let callee of this.$refs['calleeGrid'].getData()) {
          if (typeof callee.itemIndex === 'undefined' || utils.isEmpty(callee.itemIndex)) {
            callee.itemIndex = calleeCnt;            
            let obj = this.setCalleeItem(callee);
            this.outCallSchedule.createdCallees.push(obj);
            calleeCnt--;
          }          
        }

        // console.log("this.outCallSchedule.createdCallees ", this.outCallSchedule.createdCallees)
      } else {
        // 입력이나 수정모드인 경우 화면에서 '추가'한 것들을 createdCallees에 넣어 준다.
        for (let callee of this.createdCallees) {
          itemIndex++;
          callee.itemIndex = itemIndex;
          let obj = this.setCalleeItem(callee);
          this.outCallSchedule.createdCallees.push(obj);
        }
      }

      this.outCallSchedule.updatedCallees = [];
      for (let callee of this.updatedCallees) {
        let obj = this.setCalleeItem(callee);
        this.outCallSchedule.updatedCallees.push(obj);
      }

      this.outCallSchedule.removedCallees = [];
      for (let callee of this.removedCallees) {
        let obj = {};
        obj['calleeNumber'] = callee.calleeNumber;
        obj['itemIndex'] = callee.itemIndex;
        this.outCallSchedule.removedCallees.push(obj);
      }

      // 복사 모드나 csv 업로드한 경우 임시저장 이전에는 화면에서 작업한 결과를 
      // createdCallees에 넣었기 때문에 updatedCallees 나 removedCallees 값은 처리할 필요가 없다.
      if ((!this.temporarySavedFlag && this.copyMode) || this.csvUpload) { 
        this.outCallSchedule.updatedCallees = [];
        this.outCallSchedule.removedCallees = [];
      }

      // console.log("this.outCallSchedule.createdCallees", this.outCallSchedule.createdCallees)
      // console.log("this.outCallSchedule.updatedCallees", this.outCallSchedule.updatedCallees)
      // console.log("this.outCallSchedule.removedCallees", this.outCallSchedule.removedCallees)
    },

    setCalleeItem(callee) {
      // console.log(JSON.stringify(callee))
      let obj = {};
      obj['calleeNumber'] = callee.calleeNumber;

      let reservationDate = utils.toStringByFormat(callee.reservationDate, "YYYYMMDD");
      if (!utils.isEmpty(reservationDate)) {
        obj['reservationDate'] = reservationDate;
      }
      if (!utils.isEmpty(callee.reservationTime)) {
        obj['reservationTime'] = callee.reservationTime;
      }
      if (!utils.isEmpty(callee.itemIndex)) {
        obj['itemIndex'] = callee.itemIndex;
      }
      if (!utils.isEmpty(callee.itemStatus)) {
        obj['itemStatus'] = callee.itemStatus;
      }

      let outcallData = {};
      if (!utils.isEmpty(callee.runScriptOrder)) {
        outcallData['__runScriptOrder'] = callee.runScriptOrder;
      }      
      if (!utils.isEmpty(callee.customerId)) {
        obj['customerId'] = callee.customerId;
      }
      utils.forEach(this.calleeCustomColumns, customColumns => {
        outcallData[customColumns] = callee[customColumns]; 
      });
      
      // runScriptOrder 와 customColumns 값이 없는 경우 outcallData는 빈 json '{}' 이 된다.
      obj['outcallData'] = JSON.stringify(outcallData);
      
      // console.log(obj);
      return obj;
    },

    onClickFileUpdate() {
      let fileUploader = this.$refs.fileUploader;
      fileUploader.click();
    },

    onClickCsvUpload(event) {
      this.csvUpload = false;
      this.uploadedFilename = event.target.files[0].name;

      let uploadFileName = event.target.files[0].name.split(".");
      let fileExtension = utils.lowerCase(uploadFileName[uploadFileName.length-1]);
      if (fileExtension !== 'csv') {
        // console.log(fileExtension, ' is not csv')
        utils.aiccMessageBox('알림', this.$t('MSG_TXT_CSV_UPLOAD_FAIL'), '확인', 
              () => {
                  this.$refs.fileUploader.value = '';
                  this.uploadedFilename = '';
              },);
        return;
      }

      // this.$refs['uploadFileName'].value = uploadFileName;

      /**
      * 파일이 BOM(Byte Order Mark)으로 시작하는 파일인지 확인한다.
      * @param {file} file 
      * @param {function} bomCallback file이 BOM으로 시작되면 호출될 callback 함수
      * @param {function} notBomCallback file이 BOM으로 시작되지 않으면 호출될 callback 함수
      */
      aiccUtils.checkBomInFile(event.target.files[0],
        () => {
          this.loadCsvDataFile(event.target.files[0], true);
        },
        () => {
          this.loadCsvDataFile(event.target.files[0], false);
        }
      )
    },

    loadCsvDataFile(file, isUtf8) {

      // csv 에서 읽은 데이터를 json으로 변환하는 package를 import한다.
      // https://www.npmjs.com/package/convert-csv-to-json 참조
      let csvToJson = require('convert-csv-to-json');

      // fileReader를 생성하고 onload 함수를 선언한다.
      const reader = new FileReader();
      reader.onload = (rs) => {

        // console.log(rs.target.result);
        // csv 파일에 가이드 문장이 포함되어 있을 수 있으니
        // '수신번호,예약일자,예약시간,대화ID 순서,고객ID'가 있는 시작위치를 알아내고 그 이후만 데이터로 받아들인다.
        let startPosition = rs.target.result.indexOf('수신번호,예약일자,예약시간,대화ID 순서,고객ID', 0);

        // console.log('startPosition', startPosition)

        let uploadString = rs.target.result.substr(startPosition);
        // console.log(uploadString)

        if (isUtf8) {
          // console.log("utf file");
          this.csvUploadCallees = csvToJson.utf8Encoding().fieldDelimiter(',').parseSubArray('"',this.parseSubArrayDelimiter).csvStringToJson(uploadString);
          // console.log(this.csvUploadCallees)
        }
        else {
          // console.log("not utf file");
          this.csvUploadCallees = csvToJson.asciiEncoding().fieldDelimiter(',').parseSubArray('"',this.parseSubArrayDelimiter).csvStringToJson(uploadString);
        }        

        // console.log(this.csvUploadCallees);
        if (this.csvUploadCallees.length > 0) {
          this.setCalleeListFromUploadedData();
        } else {
          utils.aiccMessageBox('알림', this.$t('MSG_TXT_CSV_UPLOAD_FAIL'), '확인', 
              () => {
                  this.$refs.fileUploader.value = '';
                  this.uploadedFilename = '';
              },);
        }

      };

      // readAsText 결과가 reader.onload 함수 input으로 전달된다.
      if (isUtf8) {
        reader.readAsText(file);
      } else {
        reader.readAsText(file, "euc-kr");
      }

    },

    setCalleeListFromUploadedData() {

      this.uploadedCalleeList = [];
      let itemIndex = 1;

      // 수신리스트 컬럼이 다른지 체크 
      // 시나리오 Param 컬럼이 A,B,C인데 파일에서 더 많은 컬럼 (A,B,C,D)을 정의한 경우 포함
      // 변환된 JSON에서 키를 뽑아내면 ['수신번호', '예약일자', '예약시간', '대화ID순서', '고객ID', '기업', '고객', '가족'] 형태가 된다.
      let csvCalleeKeys = Object.keys(this.csvUploadCallees[0]);
      
      // JSON에 있는 custome 컬럼들이 모두 valid 하다고 가정한다.
      let validCustomColumns = true;
      for (let csvCalleeKey of csvCalleeKeys) {
        // 고정 컬럼 key 값은 skip 한다.
        if (csvCalleeKey === '수신번호' || csvCalleeKey === '예약일자' || csvCalleeKey === '예약시간' || csvCalleeKey === '대화ID순서' || csvCalleeKey === '고객ID') {
          continue;
        }
        // 시나리오 Param 컬럼이 있는 calleeCustomColumnsForUpload 는 {value: "company", text: "기업"} 들이 있는 배열이다.
        // JSON에서 읽은 custom 컬럼 값이 valid 하지 않다고(false) 가정하고 calleeCustomColumnsForUpload 있는 경우 true로 변경한다.
        let validCsvColumn = false;
        for (let costomColumn of this.calleeCustomColumnsForUpload) {
          if (csvCalleeKey === costomColumn.text) {
            validCsvColumn = true;
            break;
          }
        }
        // JSON에서 읽은 custom 컬럼 값이 calleeCustomColumnsForUpload 없는 경우 validCustomColumns 값을 false로 변경한다.
        if (!validCsvColumn) {
          validCustomColumns = false;
          break;
        }
      }

      if (!validCustomColumns) {
        // console.log('JSON에서 읽은 custom 컬럼 값이 DB에서 읽은 custom 컬럼에 없는 경우');
        utils.aiccMessageBox('알림', this.$t('MSG_TXT_CSV_UPLOAD_FAIL'), '확인', 
              () => {
                  this.$refs.fileUploader.value = '';
                  this.uploadedFilename = '';
              },);
        return;
      }

      // 캠페인 수정시 기존 수신인 중 진행중(B), 완료(C)인 것 들은 화면에 남겨 놓는다.
      for (let callee of this.$refs['calleeGrid'].getData()) {
        if (callee.itemStatus !== 'A') {
          this.uploadedCalleeList.push(callee);
        }        
      }
      if (this.uploadedCalleeList.length > 0) {
        itemIndex = this.calleeMaxItemIndex + 1;
      }


      // console.log(JSON.stringify(this.csvUploadCallees))
      let csvReservDate;
      for (let callee of this.csvUploadCallees) {
        // console.log(callee)
        let obj = {};
        obj['calleeNumber'] = callee["수신번호"].replaceAll("-","");

        csvReservDate = callee["예약일자"];
        if (!utils.isEmpty(csvReservDate)) {
          if(csvReservDate.length != 10 || !utils.isDate(csvReservDate)) {
            // yyyy-mm-dd 이면 10글자. 10글자도 아니고 날짜 형식도 아니면 내용을 뿌려준다.
            obj['reservationDate'] = "Invalid Date(" + csvReservDate + ")";
          }
          else {
            obj['reservationDate'] = utils.toDate(csvReservDate);
          }
        }

        obj['reservationTime'] = callee["예약시간"];

        if (Array.isArray(callee["대화ID순서"])) {
          // obj['runScriptOrder'] = callee["대화ID순서"].join(",");
          obj['runScriptOrder'] = callee["대화ID순서"].join("/");
        } else {
          if (typeof callee["대화ID순서"] !== 'undefined') {
            // obj['runScriptOrder'] = callee["대화ID순서"].replaceAll(this.parseSubArrayDelimiter,",");
            obj['runScriptOrder'] = callee["대화ID순서"];
          }        
        }

        obj['customerId'] = callee["고객ID"];
        
        utils.forEach(this.calleeCustomColumnsForUpload, customColumns => {
          obj[customColumns.value] = callee[customColumns.text];
        });
        
        obj['itemIndex'] = itemIndex;
        obj['itemStatus'] = 'A';
        itemIndex++;
        // console.log(obj)
        this.uploadedCalleeList.push(obj);
      }

      if (this.$refs['calleeGrid'].getData().length > 0) {
          utils.aiccMessageBox('알림', '파일 업로드 시, 기존에 작성한 수신리스트는 기 발신건 제외하고 모두 삭제됩니다. 파일 업로드를 진행 하시겠습니까?', 
            '확인', () => {
                this.csvUploadConfirm();
            },
            '취소', () => {
                this.$refs.fileUploader.value = '';
                this.uploadedFilename = '';
                this.onClickMessageBoxCancel();
            }
          );
      } else {
          this.csvUploadConfirm();
      }
    },

    csvUploadConfirm() {
        this.$refs['calleeGrid'].initGrid();
        
        this.dataSet.setData([]);
        this.calleeMaxItemIndex = this.uploadedCalleeList.length;
        this.csvUpload = true;

        this.dataSet.setData(this.uploadedCalleeList);
        this.validationCalleeList();
        this.$refs.fileUploader.value = '';
        
        // 중지된 캠페인 수정하는 경우 이미 발신된 것을 확인하면 rowEdit = false 가 되어 추가, 수정 버튼이 사라진다.
        // 이 때 확인한 수신인 체크를 풀면 버튼이 원복되나 그렇게 하지 않고 바로 업로드 누르면 버튼이 사라진 채로 업로드 동작이 수행된다.
        // 업로드 완료 후 원래대로 버튼이 나오게 하기 위해 rowEdit = true 하고 updateOption 을 수행한다.
        this.calleeOptions.rowEdit = true;
        this.gridLength = this.$refs['calleeGrid'].getDataSet().getRawData().length;
        this.calleeOptions.height = this.gridHeight;
        this.$nextTick(()=>{ this.$refs['calleeGrid'].updateOptions(this.calleeOptions);});
       
        
    },

    getSchedule() {
      // OutCall Schedule 한 건 가져온다.
      http.request(this.$options.name, 'DTS_AIC_00005', {
        query: this.outCallScheduleAsk,
      }).then((response) => {
        // console.log(JSON.stringify(response.data))
        this.updateData = response.data;
        this.setUpdateData(this.updateData);
        this.setSavedSchedule(this.outCallSchedule);
        this.getSipNumbersList();
        this.getScenarioList();
        // getScenarioVariable를 호출하여 custom 헤더 정보를 callee 헤더에 추가하고 수신인 정보를 가져온다.
        this.getScenarioVariable(this.updateData.scenarioId, this.updateData.scheduleId);

      }).catch((error) => {
        console.warn(error);
      });        
    },

    getSipNumbersList() {
      // outCallSipNumbersAsk는 현재 빈 값임
      http.request(this.$options.name, 'DTS_AIC_00002', {
        query: this.outCallSipNumbersAsk,
      }).then((response) => {
        // console.log(JSON.stringify(response.data));
        this.selectSipNumberOptions = [];
        
        for (var res of response.data) {
          let obj = {};
          obj['value'] = res.sipNumber + "|" + this.checkTextIsNull(res.description) + "|" + this.checkTextIsNull(res.callerId);
          obj['text'] = res.sipNumber + " : " + this.checkTextIsNull(res.description) + " | " + this.checkTextIsNull(res.callerId) + " | " + res.channels + " 채널";
          this.selectSipNumberOptions.push(obj);
        }

        // 수정모드나 복사모드면 selectSipNumberOptions 디폴트 선택 값을 바꿔준다.
        if (this.updateMode || this.copyMode) {
          for (var option of this.selectSipNumberOptions) {
            let optionArr = option.value.split('|');
            if (this.updateData.sipNumber === optionArr[0]) {
              this.selectedSipNumber = this.updateData.sipNumber + "|" + this.checkTextIsNull(this.updateData.sipNumberDescription) + "|" + this.checkTextIsNull(this.updateData.callerId);
              break;
            }
          }
          this.getOngoingSchedule(this.updateData.sipNumber);
        } else {
          this.selectedSipNumber = this.selectSipNumberOptions[0].value;
          let optionArr = this.selectedSipNumber.split('|');
          this.getOngoingSchedule(optionArr[0]);
        }

        // selectSipNumber를 checkScheduleInfo에 업데이트한다.
        this.checkScheduleInfo.selectedSipNumber = this.selectedSipNumber;
        this.checkScheduleInfoForCancelModal();
        
      }).catch((error) => {
          console.warn(error);
      });
      
    },

    getScenarioList() {
      http.request(this.$options.name, 'DTS_AID_00004', {
        query: this.outCallScenarioAsk,
      }).then((response) => {
        // console.log(JSON.stringify(response.data));
        this.selectScenarioOptions = [];
        for (var scenario of response.data) {
          let obj = {};
          obj['value'] = scenario.scenarioId;
          obj['text'] = scenario.scenarioName;
          this.selectScenarioOptions.push(obj);
          this.scenarioIdBotIdMap.set(scenario.scenarioId, scenario.botId);
        }
        
        // 수정모드나 복사모드면 selectScenarioOptions 디폴트 선택 값을 바꿔준다.
        if (this.updateMode || this.copyMode) {
          for (var option of this.selectScenarioOptions) {
            if (this.updateData.scenarioId === option.value) {
              this.selectedScenario = this.updateData.scenarioId;
              break;
            }
          }
        }

      }).catch((error) => {
          console.warn(error);
      });
    },

    getScenarioVariable(scenarioId, scheduleId) {
      // console.log(scenarioId);
      this.outCallScenarioVariableAsk.scenarioId = scenarioId;

      http.request(this.$options.name, 'DTS_AID_00005', {
        query: this.outCallScenarioVariableAsk,
      }).then((response) => {
        // console.log(JSON.stringify(response.data));
        this.calleeHeaders = this.calleeHeadersBase.slice();
        this.csvDownLoadHeaders = this.csvDownLoadHeadersBase.slice();
        this.calleeCustomColumns = [];
        this.calleeCustomColumnsForUpload = [];
        for (let variable of response.data) {
          this.calleeHeaders.push({"value": variable.variableName, "text": variable.variableMeaning,});
          this.calleeCustomColumns.push(variable.variableName);

          // 수신양식 다운로드용 헤더를 채운다.          
          this.csvDownLoadHeaders.push({"value": variable.variableName, "text": variable.variableMeaning});
          // csv 업로드시 헤더는 variableMeaning 으로 매핑한다.
          this.calleeCustomColumnsForUpload.push({"value": variable.variableName, "text": variable.variableMeaning});
        }

        // callee 헤더가 만들어졌으니 callee 정보를 가져온다.
        if (!utils.isEmpty(scheduleId)) {
          this.getCalleeInfo(scheduleId);
        }       

        // 수신양식 다운로드용 grid에 샘플데이터를 채운다. 
        this.setCsvDownloadSample();
        
      }).catch((error) => {
        console.warn(error);
      });
    },
    
    getCalleeInfo(scheduleId) {
      this.outCallScheduleItemsAsk.scheduleId = scheduleId;
      http.request(this.$options.name, 'DTS_AIC_00008', {
        query: this.outCallScheduleItemsAsk,
      }).then((response) => {
        // console.log(JSON.stringify(response.data));
        if (response.data.outCalleeInfoList.length > 0) {
          this.showEmptyMsg = false;
        }
        this.outCallSchedule.calleeInfoList = response.data.outCalleeInfoList;
        this.updateData.calleeInfoList = response.data.outCalleeInfoList;
        this.setCalleeData(this.updateData.calleeInfoList);
        this.deletedCallees = [];
      }).catch((error) => {
        console.warn(error);
      });
    },

    getOngoingSchedule(sipNumber) {
      // console.log("this.dateRangeValue ", this.dateRangeValue);
      // 새로 입력하는 캠페인 수행기간에 기 존재하는 캠페인을 가져온다.
      this.ongoingScheduleExist = false;
      this.ongoingOutCallScheduleAsk = {};
      this.ongoingOutCallScheduleAsk.sipNumber = sipNumber.replaceAll('-','');
      this.ongoingOutCallScheduleAsk.startDate = this.dateRangeValue[0].replaceAll('-','');
      this.ongoingOutCallScheduleAsk.endDate = this.dateRangeValue[1].replaceAll('-','');
      // 수정모드인 경우 자기 자신은 제외하기 위해 scheduleId 정보까지 서버로 보낸다.
      if (this.updateMode) {
        this.ongoingOutCallScheduleAsk.scheduleId = this.updateData.scheduleId;
      } else {
        this.ongoingOutCallScheduleAsk.scheduleId = "";
      }
      // console.log(this.ongoingOutCallScheduleAsk);
      http.request(this.$options.name, 'DTS_AIC_00010', {
        query: this.ongoingOutCallScheduleAsk,
      }).then((response) => {
        // console.log(JSON.stringify(response.data));
        this.ongoingScheduleCnt = 0;
        this.ongoingSchedules = [];

        if (response.data.ongoingOutCallScheduleList !== null) {
          this.ongoingScheduleExist = true;
          this.ongoingSchedules = response.data.ongoingOutCallScheduleList;
          this.ongoingScheduleCnt = response.data.ongoingOutCallScheduleList.length;
        }

      }).catch((error) => {
          console.warn(error);
      });        
    },

    existScheduleNameCheck(scheduleId, scheduleName) {
      // 복사모드인 경우 '임시저장' 이전에는 처음 입력한 캠페인명처럼 처리한다. 
      // 즉 scheduleId를 빈값으로 하여 모든 스케쥴명을 대상으로 중복체크 한다.
      // '임시저장'후에는 scheduleId 값이 생성되었으므로 해당 schduleId를 제외한 스케쥴명 대상 중복 체크한다.
      if (this.mode === 'C' && (scheduleId === this.copiedScheduleId)) {
        scheduleId = '';
      }

      scheduleName = utils.trim(scheduleName);      
      this.outCallScheduleByNameAsk.scheduleId = scheduleId;
      this.outCallScheduleByNameAsk.scheduleName = scheduleName;      
      http.request(this.$options.name, 'DTS_AIC_00018', {
        data: this.outCallScheduleByNameAsk,
      }).then((response) => {
        if (response.data.scheduleCount === 0) {
          this.scheduleNameCheckflag = true;          
        } else {
          this.scheduleNameCheckflag = false;
        }

        // scheduleNameCheckflag 값에 따라 valid 여부를 나타내기 위해 validate()를 호출한다.
        // validate() 함수를 호출하면 scheduleNameValidateRule 에 의해 
        // scheduleNameCheckflag 값이 false 인 경우 중복이라는 에러 메시지가 나타난다. (true면 에러 메시지가 나타나지 않는다.)
        
        this.$refs['refScheduleName'].validate();

        // 스케쥴명 체크가 끝났으니 step1 valid 여부를 설정한다.
        this.steps[0].valid = this.setValidStep1();
        this.checkScheduleInfoForCancelModal();

        // scheduleNameCheckflag 값이 false 일때 에러 메시지를 보여 줬으니 true로 변경한다. 
        // 이렇게 하면 스케쥴명을 변경하는 순간 scheduleNameValidateRule 동작하더라도 더 이상 에러 메시지가 나타나지 않는다.
        // scheduleNameCheckflag 값이 false 로 남아 있으면 중복 이름이라는 에러 메시지가 계속 나타난다.
        this.scheduleNameCheckflag = true;

      }).catch((error) => {
          console.warn(error);
      });
      
    },

    setSavedSchedule(outCallSchedule) {
      this.savedSchedule.scheduleId = outCallSchedule.scheduleId;
      this.savedSchedule.scheduleName = outCallSchedule.scheduleName;
      this.savedSchedule.startDate = outCallSchedule.startDate;
      this.savedSchedule.endDate = outCallSchedule.endDate;
      this.savedSchedule.startTimeLimit = outCallSchedule.startTimeLimit;
      this.savedSchedule.endTimeLimit = outCallSchedule.endTimeLimit;
    },

    setCheckScheduleDt() {      
      this.checkStartDate = this.startDateValue.replaceAll("-", "");
      this.checkEndDate = this.endDateValue.replaceAll("-", "");
      this.checkStartTimeLimit = this.convertTimeLimit(this.startTimeLimitValue);
      this.checkEndTimeLimit = this.convertTimeLimit(this.endTimeLimitValue);
    },

    setUpdateData(updateData) {      
      // console.log(JSON.stringify(updateData));

      this.outCallSchedule.scheduleId = updateData.scheduleId;
      if (this.copyMode || this.updateMode) {
        if (this.copyMode) {
          this.outCallSchedule.scheduleName = updateData.scheduleName + ' – 복사본';
        } else {
          this.outCallSchedule.scheduleName = updateData.scheduleName;
        }        
        // 복사나 중지 화면 처음 오픈시 onBlur가 발생하지 않아 중복체크가 되지 않는다. 그래서 여기서 스케쥴명 중복 체크한다.
        this.existScheduleNameCheck(this.outCallSchedule.scheduleId, this.outCallSchedule.scheduleName);
      } else {
        this.outCallSchedule.scheduleName = updateData.scheduleName;
      }

      this.scheduleNameValue = this.outCallSchedule.scheduleName;
      this.checkScheduleInfo.scheduleNameValue = this.outCallSchedule.scheduleName;

      this.outCallSchedule.scheduleStatus = updateData.scheduleStatus;

      this.outCallSchedule.sipNumber = updateData.sipNumber.replaceAll('-','');
      this.outCallSchedule.scheduleDescription = updateData.scheduleDescription;
      this.scheduleDescriptionValue = updateData.scheduleDescription;
      this.checkScheduleInfo.scheduleDescriptionValue = updateData.scheduleDescription;

      this.outCallSchedule.scenarioId = this.updateData.scenarioId;
      this.outCallSchedule.scenarioName = this.updateData.scenarioName;
      this.selectedScenarioName = this.updateData.scenarioName;
      this.selectedScenario = this.updateData.scenarioId+'|'+this.updateData.botId;
      this.checkScheduleInfo.selectedScenario = this.selectedScenario;

      this.startDateValue = utils.toStringByFormat(updateData.startDate, 'YYYY-MM-DD');
      this.endDateValue = utils.toStringByFormat(updateData.endDate, 'YYYY-MM-DD');
      this.dateRangeValue = [];
      this.dateRangeValue.push(this.startDateValue);
      this.dateRangeValue.push(this.endDateValue);
      this.checkScheduleInfo.startDateValue = this.startDateValue;
      this.checkScheduleInfo.endDateValue = this.endDateValue;

      this.startTimeLimitValue = '';
      if (!utils.isEmpty(updateData.startTimeLimit)) {
        this.startTimeLimitValue = updateData.startTimeLimit.substr(0,2) + ':' + updateData.startTimeLimit.substr(2,2);
      } 
      this.endTimeLimitValue = '';
      if (!utils.isEmpty(updateData.endTimeLimit)) {
        this.endTimeLimitValue = updateData.endTimeLimit.substr(0,2) + ':' + updateData.endTimeLimit.substr(2,2);
      }
      this.checkScheduleInfo.startTimeLimitValue = updateData.startTimeLimit;
      this.checkScheduleInfo.endTimeLimitValue = updateData.endTimeLimit;

      // 예약일자, 예약시간 체크를 위한 변수를 변경한다.
      this.setCheckScheduleDt();

      this.excludeSaturday = false;
      this.excludeSundayHoliday = false;
      let excludeSunday = false;
      let excludeHoliday = false;
      let excludeDayofweek = updateData.excludeDayofweek.split(',');
      for (var day of excludeDayofweek) {
        if (day === "7") {
          this.excludeSaturday = true;
        }
        if (day === "1") {
          excludeSunday = true;
        }
      }
      if (updateData.excludeHolidayYn === "Y") {
        excludeHoliday = true;
      }
      if (excludeSunday && excludeHoliday) {
        this.excludeSundayHoliday = true;
      }
      this.checkScheduleInfo.excludeSaturday = this.excludeSaturday;
      this.checkScheduleInfo.excludeSundayHoliday = this.excludeSundayHoliday;

      // selectRetryCountOptions index를 맞춰준다.
      // retryCount는 retryNumber + 1 이다.
      // 콜 시도 횟수 1이라는 의미는 1번만 콜 하고 retry 하지 않는다는 의미로 retryNumber는 0 이기 때문이다.
      this.selectedRetryCount = updateData.retryNumber + 1;
      this.onChangeRetryCount();
      if (updateData.retryInterval === 60) {
        this.selectedRetryInterval = 'B';
      } else {
        this.selectedRetryInterval = 'A';
      }
      this.checkScheduleInfo.selectedRetryCount = this.selectedRetryCount;
      this.checkScheduleInfo.selectedRetryInterval = this.selectedRetryInterval;   
    },

    setCalleeData(calleeInfoList) {
      // console.log('callenInfoList', calleeInfoList);
      // this.dataSet.setData([]);

      // 수신리스트 채운다.
      this.calleeItems = [];
      let copyItemIndex = 0;
      let idx = 1;

      for (var callee of calleeInfoList) {
        // console.log(JSON.stringify(callee));
        let row = _.clone(this.calleeItems0);

        // 전화번호에 하이픈이 있으면 제거한다.
        row.calleeNumber = callee.calleeNumber.replaceAll("-", "");
        if (!utils.isEmpty(callee.reservationDate)) {
          row.reservationDate = utils.toStringByFormat(utils.toDate(callee.reservationDate), 'YYYY-MM-DD');
        }
        if (!utils.isEmpty(callee.reservationTime)) {
          row.reservationTime = callee.reservationTime.substr(0,2)+':'+callee.reservationTime.substr(2,2);
        }        

        if (!utils.isEmpty(callee.outcallData)) {          
          let outcallData = JSON.parse(callee.outcallData);
          // console.log(outcallData);
          row.runScriptOrder = outcallData['__runScriptOrder'];                
          utils.forEach(this.calleeCustomColumns, customColumns => {
            row[customColumns] = outcallData[customColumns]; 
          });
        }
                
        // 복사 모드인 경우 임시저장 전 즉 최초 복사시 itemIndex 는 1번 부터 재 넘버링하고 itemStatus도 'A'로 변경한다.
        if (!this.temporarySavedFlag && this.copyMode) {
          copyItemIndex = copyItemIndex + 1;
          callee.itemIndex = copyItemIndex;
          callee.itemStatus = 'A';
        }
        row.itemStatus = callee.itemStatus;
        row.itemIndex = callee.itemIndex;        
        row.columnIndex = idx++;
        // item_index를 정해진 수신ID 포맷으로 변환
        row.calleeId = aiccUtils.stringUtil.itemIndexToCalleeId(callee.itemIndex);
        row.customerId = callee.customerId;

        this.calleeItems.push(row);
        // this.dataSet.appendData(row);
        // itemIndex 를 기존 값 중 제일 큰 값으로 바꿔 놓는다.
        if (callee.itemIndex > this.calleeMaxItemIndex) {
          this.calleeMaxItemIndex = callee.itemIndex;
        }
      }

      // console.log('setCalleeData', this.calleeItems);
      // console.log("this.calleeMaxItemIndex", this.calleeMaxItemIndex);

      this.$refs['calleeGrid'].initGrid();

      this.dataSet.setData(this.calleeItems);
      this.gridLength = this.$refs['calleeGrid'].getDataSet().getRawData().length;
      this.validationCalleeList();
      
    },

    setCsvDownloadSample() {
      // 수신번호,예약일자,예약시간,대화ID 순서,고객ID,기업,고객,가족
      // 01011112222,2021-12-31,10:00,"대화ID1|대화ID2|대화ID3|대화ID4|",customerId,기업1,고객1,가족1

      let csvDownloadSampleList = [];
      let csvDownloadSampleRow = {};
      csvDownloadSampleRow = this.getCsvDownloadSampleRow();
      csvDownloadSampleList.push(csvDownloadSampleRow);

      // csvDownloadSampleRow = {};
      // csvDownloadSampleRow = this.getCsvDownloadSampleRow();
      // delete csvDownloadSampleRow.reservationDate;
      // csvDownloadSampleList.push(csvDownloadSampleRow);
      
      // csvDownloadSampleRow = {};
      // csvDownloadSampleRow = this.getCsvDownloadSampleRow();
      // delete csvDownloadSampleRow.reservationDate;
      // delete csvDownloadSampleRow.reservationTime;
      // csvDownloadSampleList.push(csvDownloadSampleRow);

      // csvDownloadSampleRow = {};
      // csvDownloadSampleRow = this.getCsvDownloadSampleRow();
      // delete csvDownloadSampleRow.reservationDate;
      // delete csvDownloadSampleRow.reservationTime;
      // delete csvDownloadSampleRow.runScriptOrder;
      // csvDownloadSampleList.push(csvDownloadSampleRow);

      // csvDownloadSampleRow = {};
      // csvDownloadSampleRow = this.getCsvDownloadSampleRow();
      // delete csvDownloadSampleRow.reservationDate;
      // delete csvDownloadSampleRow.reservationTime;
      // delete csvDownloadSampleRow.runScriptOrder;
      // this.csvDownLoadHeaders.forEach((item, index) => {
      //   if (index > 3) {
      //     delete csvDownloadSampleRow[item.value];
      //   }
      // });
      // csvDownloadSampleList.push(csvDownloadSampleRow);

      this.csvDownloadDataSet.setData(csvDownloadSampleList);

    },

    getCsvDownloadSampleRow() {
      let csvDownloadSampleRow = {};
      csvDownloadSampleRow.calleeNumber = '(예시)0261553114';
      csvDownloadSampleRow.reservationDate = '2025-01-01';
      csvDownloadSampleRow.reservationTime = '13:00';
      csvDownloadSampleRow.runScriptOrder = 'D01-1/D02-1/D05-1/D07-2/D13-01';
      csvDownloadSampleRow.customerId = 'customerId';
      this.csvDownLoadHeaders.forEach((item, index) => {
        if (index > 3) {
          csvDownloadSampleRow[item.value] = '(예시)' + item.text;
        }
      });
      return csvDownloadSampleRow;
    },

    validationCalleeList() {
      // 1) 수신번호 중복여부
      // 2) 수신번호, 예약일자, 예약시간의 데이터 형식 오류
      // 3) 예약일자, 시간과 캠페인 수행일정 일치 여부
      // 4) 예약일시 중복여부
      // -> 1),2),3) 은 빨간색 표시, 저장 허용하지 않음
      // -> 4) 은 노란색 표시, 저장 허용

      this.calleeTotalCnt = 0;
      this.calleeTotalCnt = this.dataSet.totalSize;
      this.includeBeforeCurrentTimeReservation = false;

      this.calleeNumberTypeErrorCnt = 0;
      this.reservationDateTypeErrorCnt = 0;
      this.reservationTimeTypeErrorCnt = 0;
      this.periodDateFaultCnt = 0;
      this.periodTimeFaultCnt = 0;
      this.dupCalleeNumberCnt = 0;
      this.scriptOrderErrorCnt = 0;
      this.dupReservationDateCnt = 0;
      // this.dupReservationTimeCnt = 0;      
      
      let calleeNumberMap = new Map();
      this.filterList.dupCalleeNumber = [];

      let reservationDtMap = new Map();
      this.filterList.dupReservationDateTime = [];

      this.filterList.typeError = [];
      this.filterList.dupCalleeNumber = [];
      this.filterList.periodFault = [];
      this.filterList.dupReservationDate = [];
      this.filterList.scriptOrder = [];

      // this.dataSet.getData() 로는 데이터를 가져오지 못함
      // this.$refs['calleeGrid'].getData() 로 해야 데이터를 가져옴
      for (let callee of this.$refs['calleeGrid'].getData()) {
        // 수신리스트 '추가' 버튼 누르면 빈 란이 하나 생긴다. 이 경우 calleeNumber는 undefined 이다.
        if (typeof callee.calleeNumber === 'undefined') {
          continue;
        }

        // console.log(callee)

        // 1) 수신번호 중복여부
        if (calleeNumberMap.has(callee.calleeNumber)) {
          let count = calleeNumberMap.get(callee.calleeNumber);
          count++;
          calleeNumberMap.set(callee.calleeNumber, count);

          let filter = {value: 'calleeNumber', data: callee.calleeNumber};
          this.filterList.dupCalleeNumber.push(filter);

        } else {
          calleeNumberMap.set(callee.calleeNumber, 1);
        }

        // 2) 수신번호 데이터 형식 오류
        // 0 또는 1로 시작하는 7자리 이상 20자리 이하 숫자 입력 가능
        if (!PHONE_REGEX.test(callee.calleeNumber)) {
          this.calleeNumberTypeErrorCnt++;
          let filter = {value: 'calleeNumber', data: callee.calleeNumber};
          this.filterList.typeError.push(filter);
        }

        // 2) 예약일자 데이터 형식 오류
        if (typeof callee.reservationDate !== 'undefined' && !utils.isEmpty(callee.reservationDate) && !utils.isDate(callee.reservationDate)) {
          this.reservationDateTypeErrorCnt++;
          let typeErrorfilter = {value: 'reservationDate', data: callee.reservationDate};
          this.filterList.typeError.push(typeErrorfilter);

        } else {

          let reservationDate = utils.toStringByFormat(callee.reservationDate, "YYYY-MM-DD");

          // reseravationDate 가 있는 경우
          if (!utils.isEmpty(reservationDate)) {

              if (!DATE_REGEX.test(reservationDate)) {
                this.reservationDateTypeErrorCnt++;
                let filter = {value: 'reservationDate', data: callee.reservationDate};
                this.filterList.typeError.push(filter);
              } else {
                // 3) 예약시간과 캠페인 수행일정 일치여부 확인
                // 일치하는 경우 = 캠페인 시작일 <= 예약일 <= 캠페인 종료일 및 캠페인 시작시간 <= 예약시간 < 캠페인 종료시간
                // 예약일자 예약시간이 2021-12-26 10:00 이고 캠페인 수행일정이 21-12-06~2021-12-17 (09:00~18:00) 와 같은 경우 불일치

                if (utils.isDate(callee.reservationDate)) {
                  let reservationDate = utils.toStringByFormat(callee.reservationDate, "YYYYMMDD");
                  let reservationTime = '';
                  if (!utils.isEmpty(callee.reservationTime)) {
                    reservationTime = callee.reservationTime.replaceAll(":", "");
                  }                  

                  if (!utils.isEmpty(reservationDate) && (reservationDate < this.checkStartDate || this.checkEndDate < reservationDate)) {
                    this.periodDateFaultCnt++;
                    let periodDatefilter = {value: 'reservationDate', data: callee.reservationDate};
                    this.filterList.periodFault.push(periodDatefilter);
                  } 
                }

                let reservationTime = '';
                if (!utils.isEmpty(callee.reservationTime)) {
                  reservationTime = callee.reservationTime.replaceAll(":", "");
                } 

                if (!utils.isEmpty(reservationTime) && (reservationTime < this.checkStartTimeLimit)) {
                    this.periodTimeFaultCnt++;
                    let periodTimefilter = {value: 'reservationTime', data: callee.reservationTime};
                    this.filterList.periodFault.push(periodTimefilter);
                }
                  
                if (!utils.isEmpty(reservationTime) && (this.checkEndTimeLimit <= reservationTime)) {
                    this.periodTimeFaultCnt++;
                    let periodTimefilter = {value: 'reservationTime', data: callee.reservationTime};
                    this.filterList.periodFault.push(periodTimefilter);
                }
              }
          } else {
            // reseravationDate 가 비어 있는 경우
            let reservationTime = '';
            if (!utils.isEmpty(callee.reservationTime)) {
              reservationTime = callee.reservationTime.replaceAll(":", "");
            } 
            if (!utils.isEmpty(reservationTime) && (reservationTime < this.checkStartTimeLimit)) {
              this.periodTimeFaultCnt++;
              let periodTimefilter = {value: 'reservationTime', data: callee.reservationTime};
              this.filterList.periodFault.push(periodTimefilter);
            }              
            if (!utils.isEmpty(reservationTime) && (this.checkEndTimeLimit <= reservationTime)) {
              this.periodTimeFaultCnt++;
              let periodTimefilter = {value: 'reservationTime', data: callee.reservationTime};
              this.filterList.periodFault.push(periodTimefilter);
            }  
          }
        }

        if (typeof callee.reservationTime !== 'undefined') {
        
            // 2) 예약시간 데이터 형식 오류
            if (!utils.isEmpty(callee.reservationTime) && !TIME_REGEX.test(callee.reservationTime)) {
              this.reservationTimeTypeErrorCnt++;
              let filter = {value: 'reservationTime', data: callee.reservationTime};
              this.filterList.typeError.push(filter);
            }
        }

        if (typeof callee.reservationDate !== 'undefined' && typeof callee.reservationTime !== 'undefined') {

            let tmpReservationDateTime = '';
            if (utils.isDate(callee.reservationDate)) {
              let tmpReservationDate = utils.toStringByFormat(callee.reservationDate,'YYYYMMDD');
              let tmpReservationTime = callee.reservationTime.replaceAll(":", "");
              if (!utils.isEmpty(tmpReservationDate) && !utils.isEmpty(tmpReservationTime)) {
                tmpReservationDateTime = tmpReservationDate + tmpReservationTime;
              }
            }

            // console.log('tmpReservationDateTime', tmpReservationDateTime)

            // 4) 예약일시 중복여부
            if (!utils.isEmpty(tmpReservationDateTime)) {
              if (reservationDtMap.has(tmpReservationDateTime)) {
                let count = reservationDtMap.get(tmpReservationDateTime);
                count++;
                reservationDtMap.set(tmpReservationDateTime, count);

                // console.log('tmpReservationDateTime', tmpReservationDateTime)
                // console.log('count', count)

                let filterDate = {value: 'reservationDate', data: callee.reservationDate};
                this.filterList.dupReservationDateTime.push(filterDate);
                let filterTime = {value: 'reservationTime', data: callee.reservationTime};
                this.filterList.dupReservationDateTime.push(filterTime);

              } else {
                reservationDtMap.set(tmpReservationDateTime, 1);
              }
            }
        }

        // 수신리스트 내 전 행의 예약일자+시간 조합을 확인하여, 다음의 얼럿노출대상 케이스 발생 시
        // 얼럿 "현재일시 이전의 예약일자/시간 지정 건이 있습니다. 캠페인 진행 시 해당 건을 가장 먼저 수행합니다. [취소/확인]" 노출
        //   >>얼럿노출대상1. 현재일시 >= 예약일자+시간 조합이 존재
        //   >>얼럿노출대상2. 캠페인 총 기간이 오늘 1일이면서 (from 오늘 to 오늘) && 현재시간 >= 예약시간인 경우

        // includeBeforeCurrentTimeReservation 가 이미 true 이면 check 할 필요 없다.
        if (!this.includeBeforeCurrentTimeReservation) {
          // 캠페인 기간이 오늘 하루이고
          // 예약일자를 넣거나 안 넣거나 관계 없이 예약시간이 현재시간 보다 작으면 && 오늘이 마지막 일정이면 true
          if (this.checkStartDate === this.checkEndDate) {
            if (typeof callee.reservationTime !== 'undefined' && !utils.isEmpty(callee.reservationTime)) {
              let currentDate = this.getTodayYmd().replaceAll("-","");
              let currentTime = this.getTodayHHmm().replaceAll(":", "");
              let calleeReservationTime = callee.reservationTime.replaceAll(":", "");
              if (calleeReservationTime < currentTime && currentDate === this.checkEndDate) {
                this.includeBeforeCurrentTimeReservation = true;
              }
            }
          } else {
            // 캠페인 기간이 2일 이상이고 예약일자, 예약시간을 입력했는데
            if (typeof callee.reservationDate !== 'undefined' && !utils.isEmpty(utils.toStringByFormat(callee.reservationDate,'YYYYMMDD')) && utils.isDate(callee.reservationDate) &&
                typeof callee.reservationTime !== 'undefined' && !utils.isEmpty(callee.reservationTime)) {
              let tmpReservationDate = utils.toStringByFormat(callee.reservationDate,'YYYYMMDD');
              let tmpReservationTime = callee.reservationTime.replaceAll(":", "");
              let tmpReservationDateTime = tmpReservationDate + tmpReservationTime;
              
              let currentDate = this.getTodayYmd().replaceAll("-","");
              let currentTime = this.getTodayHHmm().replaceAll(":", "");
              let currentDateTime = currentDate + currentTime;
              // 예약일자, 예약시간이 현재일자, 현재시간 보다 작으면 && 오늘이 마지막 일정이면 true
              if (tmpReservationDateTime <= currentDateTime && currentDate === this.checkEndDate) {
                this.includeBeforeCurrentTimeReservation = true;
              }
            }
          }
        }

        // 대화ID 순서 미지정
        if (typeof callee.runScriptOrder === 'undefined' || utils.isEmpty(callee.runScriptOrder)) {
            this.scriptOrderErrorCnt++;
            let filter = {value: 'runScriptOrder', data: callee.runScriptOrder};
            this.filterList.scriptOrder.push(filter);
        }
      }

      this.dupCalleeNumberSet = new Set();
      for (let calleeNumber of calleeNumberMap) {
        // calleeNumber[0] 수신번호 calleeNumber[1] 수신번호 건수
        if (calleeNumber[1] > 1) {
          this.dupCalleeNumberSet.add(calleeNumber[0]);
          this.dupCalleeNumberCnt = this.dupCalleeNumberCnt + calleeNumber[1];
        }
      }
      
      this.dupReservationDtSet = new Set();
      for (let reservationDt of reservationDtMap) {
        // reservationDt[0] 예약일자시간 reservationDt[1] 예약일자시간 건수
        // console.log(reservationDt)
        if (reservationDt[1] > 1) {
          this.dupReservationDtSet.add(reservationDt[0]);
          this.dupReservationDateCnt = this.dupReservationDateCnt + reservationDt[1];
          // console.log("reservationDt", reservationDt)
          // this.dupReservationTimeCnt = this.dupReservationTimeCnt + reservationDt[1];
        }
      }

      // 수신리스트를 채웠으니 step3 validation을 수행한다.
      this.checkValidStep3();

    },

    checkScheduleInfoForCancelModal() {
      if (this.isCancelCheck) {
        return;
      }

      // 입력모드나 임시저장을 하지 않은 경우 step1 값 변경을 check 한다.
      if (this.mode === 'I' && !this.temporarySavedFlag) {
        if ((this.checkScheduleInfo.scheduleNameValue !== this.scheduleNameValue) 
          || (this.checkScheduleInfo.selectedScenario !== this.selectedScenario) 
          || (this.checkScheduleInfo.scheduleDescriptionValue !== this.scheduleDescriptionValue) ) {
          this.isCancelCheck = true;

          this.checkScheduleInfo.scheduleNameValue = this.scheduleNameValue;
          this.checkScheduleInfo.selectedScenario = this.selectedScenario;
          this.checkScheduleInfo.scheduleDescriptionValue = this.scheduleDescriptionValue;
          // 초기값 세팅했던 것들도 옮겨 놓는다.
          this.checkScheduleInfo.selectedRetryCount = this.selectedRetryCount;
          this.checkScheduleInfo.selectedRetryInterval = this.selectedRetryInterval;
          return;
        }
      }

      if (this.mode === 'U' || this.mode === 'UB' || this.mode === 'C' || this.temporarySavedFlag) {

        if ((!utils.isEmpty(this.checkScheduleInfo.scheduleNameValue) && this.checkScheduleInfo.scheduleNameValue !== this.scheduleNameValue) 
          || (!utils.isEmpty(this.checkScheduleInfo.selectedScenario) && this.checkScheduleInfo.selectedScenario !== this.selectedScenario) 
          || (!utils.isEmpty(this.checkScheduleInfo.scheduleDescriptionValue) && this.checkScheduleInfo.scheduleDescriptionValue !== this.scheduleDescriptionValue) 
          || ((!utils.isEmpty(this.checkScheduleInfo.startDateValue) || !utils.isEmpty(this.checkScheduleInfo.endDateValue)) && 
                            (this.checkScheduleInfo.startDateValue !== this.dateRangeValue[0] || this.checkScheduleInfo.endDateValue !== this.dateRangeValue[1])) 
          || (!utils.isEmpty(this.checkScheduleInfo.excludeSaturday) && this.checkScheduleInfo.excludeSaturday !== this.excludeSaturday) 
          || (!utils.isEmpty(this.checkScheduleInfo.excludeSundayHoliday) && this.checkScheduleInfo.excludeSundayHoliday !== this.excludeSundayHoliday) 
          || (!utils.isEmpty(this.checkScheduleInfo.startTimeLimitValue) && 
                            (this.checkScheduleInfo.startTimeLimitValue !== this.convertTimeLimit(this.startTimeLimitValue)) && !utils.isEmpty(this.startTimeLimitValue))
          || (!utils.isEmpty(this.checkScheduleInfo.endTimeLimitValue) && 
                            (this.checkScheduleInfo.endTimeLimitValue !== this.convertTimeLimit(this.endTimeLimitValue)) && !utils.isEmpty(this.endTimeLimitValue)) 
          || (!utils.isEmpty(this.checkScheduleInfo.selectedSipNumber) && this.checkScheduleInfo.selectedSipNumber !== this.selectedSipNumber) 
          || (!utils.isEmpty(this.checkScheduleInfo.selectedRetryCount) && this.checkScheduleInfo.selectedRetryCount !== this.selectedRetryCount) 
          || (!utils.isEmpty(this.checkScheduleInfo.selectedRetryInterval) && this.checkScheduleInfo.selectedRetryInterval !== this.selectedRetryInterval) ) {

          this.isCancelCheck = true;

          this.checkScheduleInfo.scheduleNameValue = this.scheduleNameValue;
          this.checkScheduleInfo.selectedScenario = this.selectedScenario;
          this.checkScheduleInfo.scheduleDescriptionValue = this.scheduleDescriptionValue;
          this.checkScheduleInfo.startDateValue = this.dateRangeValue[0];
          this.checkScheduleInfo.endDateValue = this.dateRangeValue[1];
          this.checkScheduleInfo.excludeSaturday = this.excludeSaturday;
          this.checkScheduleInfo.excludeSundayHoliday = this.excludeSundayHoliday;
          if (!utils.isEmpty(this.startTimeLimitValue)) {
            this.checkScheduleInfo.startTimeLimitValue = this.convertTimeLimit(this.startTimeLimitValue);
          }
          if (!utils.isEmpty(this.endTimeLimitValue)) {
            this.checkScheduleInfo.endTimeLimitValue = this.convertTimeLimit(this.endTimeLimitValue);
          }
          this.checkScheduleInfo.selectedSipNumber = this.selectedSipNumber;
          this.checkScheduleInfo.selectedRetryCount = this.selectedRetryCount;
          this.checkScheduleInfo.selectedRetryInterval = this.selectedRetryInterval;
          return;

        }
      }
    },

    initializeCalleeArrays() {
      this.createdCallees = [];
      this.updatedCallees = [];
      this.removedCallees = [];
    },

    initializeChipMessageFlag() {
      this.showCalleeNumberTypeErrorMsg = false;
      this.showReservationDateTypeErrorMsg = false;
      this.showReservationTimeTypeErrorMsg = false;
      this.showPeriodDateFaultMsg = false;
      this.showPeriodTimeFaultMsg = false;
      this.shoDupCalleeNumberMsg = false;
      this.showScriptOrderErrorMsg = false;
      this.showDupReservationDateMsg = false;
    },

    onClickDownload(){
      const sCsvName =`AICC_SCHEDULE_CALLEELIST_TEMPLATE_${utils.now('YYYYMMDDHHmmss')}.csv`;
      // this.$refs['csvGrid'].exportCsv(sCsvName);
      let guideText = [];

      guideText.push('※작성가이드 (업로드 시 가이드 및 예시는 삭제해 주세요)');
      guideText.push('※수신번호(필수)는 Outbound 서비스 대상 캠페인 고객 전화번호 입력 란으로 필수 항목입니다. 0 또는 1로 시작해야하며 최소 7자리 이상 ~ 최대 20자리 이하 숫자만 입력 가능합니다.');
      guideText.push('※예약일자(선택)는 수신번호별 캠페인 수행 일자를 지정할 경우 기재합니다. 기재하지 않으면 입력 수신번호가 순차적으로 발신됩니다. YYYY-MM-DD 형식으로 입력 가능합니다.');
      guideText.push('※예약시간(선택)은 수신번호별 캠페인 수행시간을 지정할 경우 기재합니다. 기재하지 않으면 입력 수신번호가 순차적으로 발신됩니다. HH:MM (24시간 4자리) 형식으로 입력 가능합니다.');
      guideText.push('※대화ID 순서를 작성하지 않은 경우 시나리오 전체를 순차 수행합니다. 대화ID 순서 작성 시 반드시 대화ID는 "/"로 구분해 주세요. (예 : D01/D02/D05)');
      guideText.push('※고객ID(선택)은 최대 100자리 이하 입력 가능합니다.');
      guideText.push('※작성 예시는 아래를 참조해 주세요. 변수값은 변수명에 따라 해당하는 값을 작성하시면 됩니다.');
      guideText.push(' ');
      aiccUtils.dataGridToCsv(this.$refs['csvGrid'], sCsvName, false, guideText);
    },

    convertTimeLimit(timeLimit) {
      let tmpTime = timeLimit.replaceAll(':', ' ').split(' ');
      // 'AM', 'PM'이 붙은 경우 24시간 표현으로 변경
      if (tmpTime[3] === 'AM' || tmpTime[3] === 'PM') {
        // 12:10 AM (새벽), 12:10 PM(오후)의 경우 '12'를 '00'으로 변경
        if (tmpTime[0] === '12') {
          tmpTime[0] = '00';
        }
        // 'PM' 이면 +12 
        if (tmpTime[3] === 'PM') {
          tmpTime[0] = parseInt(tmpTime[0]) + 12;
        }        
      } else {
        // 24시간 표현인 경우 0 ~ 9시 까지는 '0'을 앞에 붙임
        if (tmpTime[0].length === 1) {
          tmpTime[0] = '0' + tmpTime[0];
        }
      }
      return tmpTime[0]+tmpTime[1];
    },

    checkTextIsNull(value) {
     if (utils.isEmpty(value)) {
        return '-';
      } else {
        return value;  
      }
    },

    sendOutCallInfoToParent() {
      // if (typeof opener.parent.setOutCallSchduleInfoFromChild === 'undefined' || opener.parent.setOutCallSchduleInfoFromChild === null) {
      //   console.log('opener.parent.setOutCallSchduleInfoFromChild is not defined yet.');
      // } else {
      //   opener.parent.setOutCallSchduleInfoFromChild(this.mode, this.outCallSchedule);
      // }
      opener.modeValueFromChild = this.mode;
      opener.outCallSchduleInfoFromChild = this.outCallSchedule;
    },

    getTodayYmdHHmmss() {
      return utils.now('YYYY-MM-DD HH:mm:ss');
    },
    getTodayYmdHHmm() {
      return utils.now('YYYY-MM-DD HH:mm');
    },
    getTodayYmd() {
      return utils.now('YYYY-MM-DD');
    },
    getTodayHHmm() {
      return utils.now('HH:mm');
    },

    wsConnect() {
			if(this.aiccWebSocket !== null && !utils.isEmpty(this.aiccWebSocket)){
        console.warn('this.aiccWebSocket not null')
				return;
			}

			this.aiccWebSocket = new aiccWsSession();
			
			// arrow 함수를 써야 콜백 함수 안에 있는 여기 data()에서 선언한 것을 쓰게 된다.			
			this.aiccWebSocket.setConnectHandler(() => {
				console.log('WebSocket connection opened');
			  this.sendModifyScheduleStartAsk();
			});

			this.aiccWebSocket.setCloseHandler(() => {
				console.log('WebSocket connection closed.');
				this.wsDisconnect(false);
			});
			
			this.aiccWebSocket.setErrorHandler(() => {
				console.warn('WebSocket error occured.');				
        utils.aiccMessageBox('알림', '웹소켓 서버 오류로 연결이 종료되었습니다.', 
          '확인', () => {
            window.close()
          });
			});

			this.aiccWebSocket.setHandler("ModifyScheduleStartRep", (data) => {
				this.receiveModifyScheduleStartRep(data);
			});

      // 웹소켓 url은 window.location 에 있는 값들로 구성한다.

      // console.log("window.location", window.location)
      // hash: "#/PGE_AIC_00003?mode=U&scheduleId=0389f2e66c5f43c99688d757cf73faa7"
      // host: "localhost:8888"
      // hostname: "localhost"
      // href: "http://localhost:8888/home/saas1/popup.html#/PGE_AIC_00003?mode=U&scheduleId=0389f2e66c5f43c99688d757cf73faa7"
      // origin: "http://localhost:8888"
      // pathname: "/home/saas1/popup.html"
      // port: "8888"
      // protocol: "http:"
      // window.location.protocol은 "http:" 또는 "https:"이므로 http를 ws로 바꾸면 "ws:" 또는 "wss:"가 된다.

      let url = '';
			if (window.location.hostname === 'localhost') {
        url = window.location.protocol.replace("http", "ws") + "//" + window.location.hostname + ":8080/ws/aicc/outcallschedule";
			} else {
				url = window.location.protocol.replace("http", "ws") + "//" + window.location.host + "/ws/aicc/outcallschedule";
			}
			
      // 웹소켓 url 조합된 결과는 로컬, 계발계, AWS 각각 아래와 같다.
      
      // url = "wss://localhost:8080/ws/aicc/outcallschedule";
      // url = "ws://182.193.18.205:8080/ws/aicc/outcallschedule";
      // url = "wss://dev.aicc.samsungsds.com/ws/aicc/outcallschedule";

			// console.log(url);
			this.aiccWebSocket.connect(url);
		},

		wsDisconnect() {
			console.log("WebSocket is closed.");
      this.aiccWebSocket.disconnect();
      this.aiccWebSocket = null;
		},

    sendModifyScheduleStartAsk() {
      this.aiccWebSocket.startModifySchedule(this.outCallScheduleAsk.scheduleId);
    },

    receiveModifyScheduleStartRep(data) {
      // console.log(JSON.stringify(data));
      if (data.reply.code === '0000') {
        this.getSchedule();
      } else {
        console.log(data);
        this.showSnackbar(data.reply.korMsg);
      }

    },

  },
};
</script>

<style scoped>
.tbl_write th {
  text-align: left;
  padding:0;
}
::v-deep .ur-time-picker.ur-input.aicc-red-time-picker.ur-time-picker--medium > .ur-time-picker-time--medium > .ur-counter.ur-input.ur-counter--medium.ur-counter--center {
  border-color:#ff5858;
}
::v-deep .ur-data-grid > .ur-data-grid__table > 
.ur-data-grid__content.ur-data-grid__content--infinity > .ur-data-grid__content__scroll-wrapper > .ur-data-grid__content__scorll-holder > 
.ur-data-grid__content__row.ur-data-grid__content__row--dirty.ur-data-grid__content__row--dirty--created > 
.ur-data-grid__content__cell.ur-data-grid__content__cell--checkbox {    
    height: 48px;
    flex: 0 0 34px;
    min-width: 0px;
    margin-left: 3px;
}
::v-deep .ur-data-grid > .ur-data-grid__table > 
.ur-data-grid__content.ur-data-grid__content--infinity > .ur-data-grid__content__scroll-wrapper > .ur-data-grid__content__scorll-holder > 
.ur-data-grid__content__row > 
.ur-data-grid__content__cell.ur-data-grid__content__cell--checkbox {    
    height: 48px;
    flex: 0 0 34px;
    min-width: 0px;
    margin-left: 3px;
}
/* ::v-deep .ur-data-grid > .ur-data-grid__table > .ur-data-grid__content > .ur-data-grid__content__scroll-wrapper 
> .ur-data-grid__content__row.ur-data-grid__content--empty__row{
  height: 240px;
} 
::v-deep .ur-data-grid > .ur-data-grid__table{
  height: auto;
  max-height: 432px;
  min-height: 240px;
  margin:0;
  border-bottom: 0;
}
::v-deep .ur-data-grid > .ur-data-grid__table > .ur-data-grid__content  {
  height: auto;
  max-height: 432px;
  min-height: 240px;
}
::v-deep .ur-data-grid > .ur-data-grid__table > .ur-data-grid__content > .ur-data-grid__content__scroll-wrapper {
  height: auto;
  max-height: 432px;
  min-height: 240px;
}

::v-deep .ur-data-grid > .ur-data-grid__table > 
.ur-data-grid__content > .ur-data-grid__content--infinity  {    
    height: auto;
    max-height: 432px;
    min-height: 240px;
}

::v-deep .ur-data-grid > .ur-data-grid__table > 
.ur-data-grid__content > .ur-data-grid__content--infinity > .ur-data-grid__content__scroll-wrapper {    
    height: auto;
    max-height: 432px;
    min-height: 240px;
} */

::v-deep .ur-filter-chip__container.ur-filter-chip__container-medium.ur-filter-chip__container-normal-filter {    
    cursor:pointer;
}
::v-deep .ur-filter-chip__container.ur-filter-chip__container-medium.ur-filter-chip__container-red-filter {    
    cursor:pointer;
}
::v-deep .ur-filter-chip__container.ur-filter-chip__container-medium.ur-filter-chip__container-orange-filter {    
    cursor:pointer;
}
.box_gray{
  width:1120px;
}
.tbl_write table{
  margin: 0 32px 0;
}
.tbl_write table th{
  padding: 20px;
}

.empty-view{
     position: absolute;
     top: 625px;
     left: 50%;
     transform: translate(-50%, -50%);                                                                   
     font-size: 20px;
     color: black;
     z-index: 2;
     text-align: center;
}

</style>
